// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: common/types.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

export const protobufPackage = 'common.types'

/**
 * `Exchange` identifies an underlying market — the venue where a contract is
 * listed and traded. Routing/execution identity belongs on `TradeVenue`; the
 * two are independent.
 */
export enum Exchange {
  EXCHANGE_UNSPECIFIED = 0,
  /** EXCHANGE_BINANCE - Full-stack venues — also appear in TradeVenue. */
  EXCHANGE_BINANCE = 1,
  EXCHANGE_DERIBIT = 2,
  /** EXCHANGE_HYPERLIQUID - Hyperliquid + HIP-3 DEXes (ENG-455). Virtual market, not a provider. */
  EXCHANGE_HYPERLIQUID = 5,
  /**
   * EXCHANGE_GLBX - Databento-backed markets. Add a variant + explicit dataset/publisher
   * mapping in `databento::conversions` for every Databento venue the system
   * supports before publishing data for it. Never emit a placeholder
   * `EXCHANGE_DATABENTO` in market-data protos.
   */
  EXCHANGE_GLBX = 6,
  EXCHANGE_XNAS = 7,
  EXCHANGE_XNYS = 8,
  EXCHANGE_OPRA = 9,
  EXCHANGE_BYBIT = 10,
  /**
   * EXCHANGE_POLYMARKET - Polymarket prediction markets (ENG-530). Data-only signal source for
   * trigger conditions; intentionally has no matching TradeVenue — we read
   * probabilities, never execute here.
   */
  EXCHANGE_POLYMARKET = 11,
  EXCHANGE_UPBIT = 12,
  /** EXCHANGE_DERIVE - Full-stack venue — also appears in TradeVenue (see comment above) */
  EXCHANGE_DERIVE = 13,
  EXCHANGE_LIGHTER = 14,
  /** EXCHANGE_XKRX - Korea Exchange — brokered via TRADE_VENUE_TOSS, not databento-backed. */
  EXCHANGE_XKRX = 15,
  /**
   * EXCHANGE_COINBASE - Coinbase Exchange. Data-only, and deliberately has no TradeVenue: we read
   * its tape, never execute here. It is the matching engine behind Deribit's
   * routed spot pairs (`Instrument.is_externally_routed`) — Deribit mirrors
   * the book for those but publishes no trades, so this is the only source of
   * their prints.
   */
  EXCHANGE_COINBASE = 16,
  /**
   * EXCHANGE_PAPERTRADE - Papertrade (papertrade.xyz): synthetic BTC/ETH perps on HyperEVM priced off
   * the Hyperliquid mid. Market data is our own Hyperliquid ticker republished
   * under this exchange (bid = ask = mark = mid); there is no order book.
   */
  EXCHANGE_PAPERTRADE = 17,
  UNRECOGNIZED = -1,
}

export function exchangeFromJSON(object: any): Exchange {
  switch (object) {
    case 0:
    case 'EXCHANGE_UNSPECIFIED':
      return Exchange.EXCHANGE_UNSPECIFIED
    case 1:
    case 'EXCHANGE_BINANCE':
      return Exchange.EXCHANGE_BINANCE
    case 2:
    case 'EXCHANGE_DERIBIT':
      return Exchange.EXCHANGE_DERIBIT
    case 5:
    case 'EXCHANGE_HYPERLIQUID':
      return Exchange.EXCHANGE_HYPERLIQUID
    case 6:
    case 'EXCHANGE_GLBX':
      return Exchange.EXCHANGE_GLBX
    case 7:
    case 'EXCHANGE_XNAS':
      return Exchange.EXCHANGE_XNAS
    case 8:
    case 'EXCHANGE_XNYS':
      return Exchange.EXCHANGE_XNYS
    case 9:
    case 'EXCHANGE_OPRA':
      return Exchange.EXCHANGE_OPRA
    case 10:
    case 'EXCHANGE_BYBIT':
      return Exchange.EXCHANGE_BYBIT
    case 11:
    case 'EXCHANGE_POLYMARKET':
      return Exchange.EXCHANGE_POLYMARKET
    case 12:
    case 'EXCHANGE_UPBIT':
      return Exchange.EXCHANGE_UPBIT
    case 13:
    case 'EXCHANGE_DERIVE':
      return Exchange.EXCHANGE_DERIVE
    case 14:
    case 'EXCHANGE_LIGHTER':
      return Exchange.EXCHANGE_LIGHTER
    case 15:
    case 'EXCHANGE_XKRX':
      return Exchange.EXCHANGE_XKRX
    case 16:
    case 'EXCHANGE_COINBASE':
      return Exchange.EXCHANGE_COINBASE
    case 17:
    case 'EXCHANGE_PAPERTRADE':
      return Exchange.EXCHANGE_PAPERTRADE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return Exchange.UNRECOGNIZED
  }
}

export function exchangeToJSON(object: Exchange): string {
  switch (object) {
    case Exchange.EXCHANGE_UNSPECIFIED:
      return 'EXCHANGE_UNSPECIFIED'
    case Exchange.EXCHANGE_BINANCE:
      return 'EXCHANGE_BINANCE'
    case Exchange.EXCHANGE_DERIBIT:
      return 'EXCHANGE_DERIBIT'
    case Exchange.EXCHANGE_HYPERLIQUID:
      return 'EXCHANGE_HYPERLIQUID'
    case Exchange.EXCHANGE_GLBX:
      return 'EXCHANGE_GLBX'
    case Exchange.EXCHANGE_XNAS:
      return 'EXCHANGE_XNAS'
    case Exchange.EXCHANGE_XNYS:
      return 'EXCHANGE_XNYS'
    case Exchange.EXCHANGE_OPRA:
      return 'EXCHANGE_OPRA'
    case Exchange.EXCHANGE_BYBIT:
      return 'EXCHANGE_BYBIT'
    case Exchange.EXCHANGE_POLYMARKET:
      return 'EXCHANGE_POLYMARKET'
    case Exchange.EXCHANGE_UPBIT:
      return 'EXCHANGE_UPBIT'
    case Exchange.EXCHANGE_DERIVE:
      return 'EXCHANGE_DERIVE'
    case Exchange.EXCHANGE_LIGHTER:
      return 'EXCHANGE_LIGHTER'
    case Exchange.EXCHANGE_XKRX:
      return 'EXCHANGE_XKRX'
    case Exchange.EXCHANGE_COINBASE:
      return 'EXCHANGE_COINBASE'
    case Exchange.EXCHANGE_PAPERTRADE:
      return 'EXCHANGE_PAPERTRADE'
    case Exchange.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * `TradeVenue` is the execution broker / venue identity used for account
 * creation, order routing, and order management. An account is identified by
 * its trade venue, not by the underlying market.
 */
export enum TradeVenue {
  TRADE_VENUE_UNSPECIFIED = 0,
  TRADE_VENUE_DERIBIT = 1,
  TRADE_VENUE_IBKR = 2,
  TRADE_VENUE_BINANCE = 3,
  TRADE_VENUE_BYBIT = 4,
  TRADE_VENUE_HYPERLIQUID = 5,
  TRADE_VENUE_UPBIT = 6,
  TRADE_VENUE_DERIVE = 7,
  TRADE_VENUE_LIGHTER = 8,
  TRADE_VENUE_TOSS = 9,
  TRADE_VENUE_PAPERTRADE = 10,
  UNRECOGNIZED = -1,
}

export function tradeVenueFromJSON(object: any): TradeVenue {
  switch (object) {
    case 0:
    case 'TRADE_VENUE_UNSPECIFIED':
      return TradeVenue.TRADE_VENUE_UNSPECIFIED
    case 1:
    case 'TRADE_VENUE_DERIBIT':
      return TradeVenue.TRADE_VENUE_DERIBIT
    case 2:
    case 'TRADE_VENUE_IBKR':
      return TradeVenue.TRADE_VENUE_IBKR
    case 3:
    case 'TRADE_VENUE_BINANCE':
      return TradeVenue.TRADE_VENUE_BINANCE
    case 4:
    case 'TRADE_VENUE_BYBIT':
      return TradeVenue.TRADE_VENUE_BYBIT
    case 5:
    case 'TRADE_VENUE_HYPERLIQUID':
      return TradeVenue.TRADE_VENUE_HYPERLIQUID
    case 6:
    case 'TRADE_VENUE_UPBIT':
      return TradeVenue.TRADE_VENUE_UPBIT
    case 7:
    case 'TRADE_VENUE_DERIVE':
      return TradeVenue.TRADE_VENUE_DERIVE
    case 8:
    case 'TRADE_VENUE_LIGHTER':
      return TradeVenue.TRADE_VENUE_LIGHTER
    case 9:
    case 'TRADE_VENUE_TOSS':
      return TradeVenue.TRADE_VENUE_TOSS
    case 10:
    case 'TRADE_VENUE_PAPERTRADE':
      return TradeVenue.TRADE_VENUE_PAPERTRADE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TradeVenue.UNRECOGNIZED
  }
}

export function tradeVenueToJSON(object: TradeVenue): string {
  switch (object) {
    case TradeVenue.TRADE_VENUE_UNSPECIFIED:
      return 'TRADE_VENUE_UNSPECIFIED'
    case TradeVenue.TRADE_VENUE_DERIBIT:
      return 'TRADE_VENUE_DERIBIT'
    case TradeVenue.TRADE_VENUE_IBKR:
      return 'TRADE_VENUE_IBKR'
    case TradeVenue.TRADE_VENUE_BINANCE:
      return 'TRADE_VENUE_BINANCE'
    case TradeVenue.TRADE_VENUE_BYBIT:
      return 'TRADE_VENUE_BYBIT'
    case TradeVenue.TRADE_VENUE_HYPERLIQUID:
      return 'TRADE_VENUE_HYPERLIQUID'
    case TradeVenue.TRADE_VENUE_UPBIT:
      return 'TRADE_VENUE_UPBIT'
    case TradeVenue.TRADE_VENUE_DERIVE:
      return 'TRADE_VENUE_DERIVE'
    case TradeVenue.TRADE_VENUE_LIGHTER:
      return 'TRADE_VENUE_LIGHTER'
    case TradeVenue.TRADE_VENUE_TOSS:
      return 'TRADE_VENUE_TOSS'
    case TradeVenue.TRADE_VENUE_PAPERTRADE:
      return 'TRADE_VENUE_PAPERTRADE'
    case TradeVenue.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Instrument kind enum */
export enum InstrumentKind {
  INSTRUMENT_KIND_UNSPECIFIED = 0,
  INSTRUMENT_KIND_SPOT = 1,
  INSTRUMENT_KIND_FUTURE = 2,
  INSTRUMENT_KIND_OPTION = 3,
  INSTRUMENT_KIND_INDEX = 4,
  /** INSTRUMENT_KIND_OTHER - INSTRUMENT_KIND_PERPETUAL = 3; */
  INSTRUMENT_KIND_OTHER = 5,
  UNRECOGNIZED = -1,
}

export function instrumentKindFromJSON(object: any): InstrumentKind {
  switch (object) {
    case 0:
    case 'INSTRUMENT_KIND_UNSPECIFIED':
      return InstrumentKind.INSTRUMENT_KIND_UNSPECIFIED
    case 1:
    case 'INSTRUMENT_KIND_SPOT':
      return InstrumentKind.INSTRUMENT_KIND_SPOT
    case 2:
    case 'INSTRUMENT_KIND_FUTURE':
      return InstrumentKind.INSTRUMENT_KIND_FUTURE
    case 3:
    case 'INSTRUMENT_KIND_OPTION':
      return InstrumentKind.INSTRUMENT_KIND_OPTION
    case 4:
    case 'INSTRUMENT_KIND_INDEX':
      return InstrumentKind.INSTRUMENT_KIND_INDEX
    case 5:
    case 'INSTRUMENT_KIND_OTHER':
      return InstrumentKind.INSTRUMENT_KIND_OTHER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return InstrumentKind.UNRECOGNIZED
  }
}

export function instrumentKindToJSON(object: InstrumentKind): string {
  switch (object) {
    case InstrumentKind.INSTRUMENT_KIND_UNSPECIFIED:
      return 'INSTRUMENT_KIND_UNSPECIFIED'
    case InstrumentKind.INSTRUMENT_KIND_SPOT:
      return 'INSTRUMENT_KIND_SPOT'
    case InstrumentKind.INSTRUMENT_KIND_FUTURE:
      return 'INSTRUMENT_KIND_FUTURE'
    case InstrumentKind.INSTRUMENT_KIND_OPTION:
      return 'INSTRUMENT_KIND_OPTION'
    case InstrumentKind.INSTRUMENT_KIND_INDEX:
      return 'INSTRUMENT_KIND_INDEX'
    case InstrumentKind.INSTRUMENT_KIND_OTHER:
      return 'INSTRUMENT_KIND_OTHER'
    case InstrumentKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum InstrumentType {
  INSTRUMENT_TYPE_UNSPECIFIED = 0,
  /** INSTRUMENT_TYPE_LINEAR - Futures/Perpetuals settled in quote currency */
  INSTRUMENT_TYPE_LINEAR = 1,
  /** INSTRUMENT_TYPE_INVERSE - Futures/Perpetuals settled in base currency */
  INSTRUMENT_TYPE_INVERSE = 2,
  UNRECOGNIZED = -1,
}

export function instrumentTypeFromJSON(object: any): InstrumentType {
  switch (object) {
    case 0:
    case 'INSTRUMENT_TYPE_UNSPECIFIED':
      return InstrumentType.INSTRUMENT_TYPE_UNSPECIFIED
    case 1:
    case 'INSTRUMENT_TYPE_LINEAR':
      return InstrumentType.INSTRUMENT_TYPE_LINEAR
    case 2:
    case 'INSTRUMENT_TYPE_INVERSE':
      return InstrumentType.INSTRUMENT_TYPE_INVERSE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return InstrumentType.UNRECOGNIZED
  }
}

export function instrumentTypeToJSON(object: InstrumentType): string {
  switch (object) {
    case InstrumentType.INSTRUMENT_TYPE_UNSPECIFIED:
      return 'INSTRUMENT_TYPE_UNSPECIFIED'
    case InstrumentType.INSTRUMENT_TYPE_LINEAR:
      return 'INSTRUMENT_TYPE_LINEAR'
    case InstrumentType.INSTRUMENT_TYPE_INVERSE:
      return 'INSTRUMENT_TYPE_INVERSE'
    case InstrumentType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Market Data Type enum */
export enum MarketDataType {
  MARKET_DATA_TYPE_UNSPECIFIED = 0,
  MARKET_DATA_TYPE_ORDER_BOOK = 1,
  MARKET_DATA_TYPE_TICKER = 2,
  MARKET_DATA_TYPE_TRADES = 3,
  MARKET_DATA_TYPE_INCREMENTAL_TICKER = 4,
  MARKET_DATA_TYPE_INSTRUMENT_STATE = 5,
  /**
   * MARKET_DATA_TYPE_OI_PRESSURE - Per-side open interest (long/short OI x mark), published per symbol on
   * the market-data stream. Papertrade: polled from `GET /state/trading`
   * every 5 s, not the `pressure:current` channel. A per-symbol market-data
   * stream, so it belongs here and not on AnalyticsType.
   */
  MARKET_DATA_TYPE_OI_PRESSURE = 6,
  /**
   * MARKET_DATA_TYPE_LIQUIDATIONS - Trades already published on MARKET_DATA_TYPE_TRADES, republished with
   * `liquidation` set once the venue's separate liquidation feed names them
   * (Bybit `allLiquidation`, which lags the trade). An InstrumentTradeList.
   * Fold these into liquidation totals only: their volume is already counted.
   * Venues that tag liquidations on the trade itself never publish it.
   */
  MARKET_DATA_TYPE_LIQUIDATIONS = 7,
  UNRECOGNIZED = -1,
}

export function marketDataTypeFromJSON(object: any): MarketDataType {
  switch (object) {
    case 0:
    case 'MARKET_DATA_TYPE_UNSPECIFIED':
      return MarketDataType.MARKET_DATA_TYPE_UNSPECIFIED
    case 1:
    case 'MARKET_DATA_TYPE_ORDER_BOOK':
      return MarketDataType.MARKET_DATA_TYPE_ORDER_BOOK
    case 2:
    case 'MARKET_DATA_TYPE_TICKER':
      return MarketDataType.MARKET_DATA_TYPE_TICKER
    case 3:
    case 'MARKET_DATA_TYPE_TRADES':
      return MarketDataType.MARKET_DATA_TYPE_TRADES
    case 4:
    case 'MARKET_DATA_TYPE_INCREMENTAL_TICKER':
      return MarketDataType.MARKET_DATA_TYPE_INCREMENTAL_TICKER
    case 5:
    case 'MARKET_DATA_TYPE_INSTRUMENT_STATE':
      return MarketDataType.MARKET_DATA_TYPE_INSTRUMENT_STATE
    case 6:
    case 'MARKET_DATA_TYPE_OI_PRESSURE':
      return MarketDataType.MARKET_DATA_TYPE_OI_PRESSURE
    case 7:
    case 'MARKET_DATA_TYPE_LIQUIDATIONS':
      return MarketDataType.MARKET_DATA_TYPE_LIQUIDATIONS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MarketDataType.UNRECOGNIZED
  }
}

export function marketDataTypeToJSON(object: MarketDataType): string {
  switch (object) {
    case MarketDataType.MARKET_DATA_TYPE_UNSPECIFIED:
      return 'MARKET_DATA_TYPE_UNSPECIFIED'
    case MarketDataType.MARKET_DATA_TYPE_ORDER_BOOK:
      return 'MARKET_DATA_TYPE_ORDER_BOOK'
    case MarketDataType.MARKET_DATA_TYPE_TICKER:
      return 'MARKET_DATA_TYPE_TICKER'
    case MarketDataType.MARKET_DATA_TYPE_TRADES:
      return 'MARKET_DATA_TYPE_TRADES'
    case MarketDataType.MARKET_DATA_TYPE_INCREMENTAL_TICKER:
      return 'MARKET_DATA_TYPE_INCREMENTAL_TICKER'
    case MarketDataType.MARKET_DATA_TYPE_INSTRUMENT_STATE:
      return 'MARKET_DATA_TYPE_INSTRUMENT_STATE'
    case MarketDataType.MARKET_DATA_TYPE_OI_PRESSURE:
      return 'MARKET_DATA_TYPE_OI_PRESSURE'
    case MarketDataType.MARKET_DATA_TYPE_LIQUIDATIONS:
      return 'MARKET_DATA_TYPE_LIQUIDATIONS'
    case MarketDataType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Discriminator for analytic timeseries. Most values name a "processed" /
 * cron-polled series carried on the `analytics_stream.*` subject family, but
 * not all of them do: several are derived on read from stored tables and have
 * no producer, no stream and no snapshot, so do not go looking for a subject
 * that was never created. MUST NOT be added onto `MarketDataType` — that
 * enum is reserved for upstream-Subscribe-driven raw market data only.
 */
export enum AnalyticsType {
  ANALYTICS_TYPE_UNSPECIFIED = 0,
  ANALYTICS_TYPE_VOL_METRICS_24HR = 1,
  ANALYTICS_TYPE_PUT_CALL_RATIO = 2,
  ANALYTICS_TYPE_DELTA_SURFACE_CONSTANT = 3,
  ANALYTICS_TYPE_DELTA_SURFACE_FLOATING = 4,
  ANALYTICS_TYPE_IMPLIED_VS_REALIZED = 5,
  ANALYTICS_TYPE_TERM_STRUCTURE_CONSTANT = 6,
  ANALYTICS_TYPE_TERM_STRUCTURE_FLOATING = 7,
  ANALYTICS_TYPE_TERM_STRUCTURE_RICHNESS = 8,
  /**
   * ANALYTICS_TYPE_VOLATILITY_INDEX - DVOL was relayed, not computed, so nothing produces this stream any more
   * and it is entitled on no tier. Historical rows remain readable.
   *
   * @deprecated
   */
  ANALYTICS_TYPE_VOLATILITY_INDEX = 9,
  /**
   * ANALYTICS_TYPE_SKEW_CONSTANT - Derived on read from the delta-surface tables (call_delta - put_delta);
   * range-only, no producer/stream/KV snapshot of its own.
   */
  ANALYTICS_TYPE_SKEW_CONSTANT = 10,
  ANALYTICS_TYPE_SKEW_FLOATING = 11,
  /** ANALYTICS_TYPE_USD_GAMMA - Aggregate dealer gamma normalized to USD, inferred from the taker tape. */
  ANALYTICS_TYPE_USD_GAMMA = 12,
  /** ANALYTICS_TYPE_GEX - Per-instrument dealer gamma exposure snapshot, from the same tape. */
  ANALYTICS_TYPE_GEX = 13,
  /** ANALYTICS_TYPE_VOL_CONES - Realized volatility (spot-keyed): cones + seasonality. */
  ANALYTICS_TYPE_VOL_CONES = 14,
  ANALYTICS_TYPE_RV_SEASONALITY_DOW = 15,
  ANALYTICS_TYPE_RV_SEASONALITY_MOY = 16,
  /**
   * ANALYTICS_TYPE_FEDWATCH - CME FedWatch target-rate probabilities, derived from the 30-Day Fed Funds
   * (ZQ) strip. Keyed on the futures root rather than a currency.
   */
  ANALYTICS_TYPE_FEDWATCH = 17,
  /**
   * ANALYTICS_TYPE_RETURNS_DOW - Bucketed historical returns computed on read from the chart MVs; no
   * producer, no snapshot. DOW/HOUR are flat distributions; SESSION uses 8h
   * blocks anchored to the venue's trade date, and SESSION_CUMULATIVE is the
   * compounded curve per block over time.
   */
  ANALYTICS_TYPE_RETURNS_DOW = 18,
  ANALYTICS_TYPE_RETURNS_HOUR = 19,
  ANALYTICS_TYPE_RETURNS_SESSION = 20,
  ANALYTICS_TYPE_RETURNS_SESSION_CUMULATIVE = 21,
  /**
   * ANALYTICS_TYPE_LIQUIDATION_LEVELS - Predicted liquidation prices of currently-open perpetual positions,
   * bucketed into a price profile. Distinct from VisibleRangeProfile's
   * buy/sell_liquidation_* arrays, which are realized liquidation fills.
   */
  ANALYTICS_TYPE_LIQUIDATION_LEVELS = 22,
  /**
   * ANALYTICS_TYPE_STOP_LEVELS - Resting TP/SL trigger prices, bucketed into a price profile. Keyed on an
   * instrument (`BTC-PERP`) rather than a currency, like the type above.
   */
  ANALYTICS_TYPE_STOP_LEVELS = 23,
  /**
   * ANALYTICS_TYPE_SVI - Per-expiry SVI parameters. No history before the cutover on either side:
   * the fit that preceded it went to a KV bucket with a five-minute TTL and no
   * table.
   */
  ANALYTICS_TYPE_SVI = 24,
  /**
   * ANALYTICS_TYPE_RV_SEASONALITY_HOUR - Realized vol by hour of day (UTC). Same shape and same producer as the
   * weekday and month series; only the calendar axis differs.
   */
  ANALYTICS_TYPE_RV_SEASONALITY_HOUR = 25,
  /**
   * ANALYTICS_TYPE_PERP_POSITIONS - Per-market perp positions table: top holders by notional plus aggregates.
   * Produced by data-provider-hydromancer, exchange-lighter-data and
   * exchange-derive-data; KV-only (ANALYTIC_SNAPSHOTS), never written to QuestDB.
   */
  ANALYTICS_TYPE_PERP_POSITIONS = 26,
  UNRECOGNIZED = -1,
}

export function analyticsTypeFromJSON(object: any): AnalyticsType {
  switch (object) {
    case 0:
    case 'ANALYTICS_TYPE_UNSPECIFIED':
      return AnalyticsType.ANALYTICS_TYPE_UNSPECIFIED
    case 1:
    case 'ANALYTICS_TYPE_VOL_METRICS_24HR':
      return AnalyticsType.ANALYTICS_TYPE_VOL_METRICS_24HR
    case 2:
    case 'ANALYTICS_TYPE_PUT_CALL_RATIO':
      return AnalyticsType.ANALYTICS_TYPE_PUT_CALL_RATIO
    case 3:
    case 'ANALYTICS_TYPE_DELTA_SURFACE_CONSTANT':
      return AnalyticsType.ANALYTICS_TYPE_DELTA_SURFACE_CONSTANT
    case 4:
    case 'ANALYTICS_TYPE_DELTA_SURFACE_FLOATING':
      return AnalyticsType.ANALYTICS_TYPE_DELTA_SURFACE_FLOATING
    case 5:
    case 'ANALYTICS_TYPE_IMPLIED_VS_REALIZED':
      return AnalyticsType.ANALYTICS_TYPE_IMPLIED_VS_REALIZED
    case 6:
    case 'ANALYTICS_TYPE_TERM_STRUCTURE_CONSTANT':
      return AnalyticsType.ANALYTICS_TYPE_TERM_STRUCTURE_CONSTANT
    case 7:
    case 'ANALYTICS_TYPE_TERM_STRUCTURE_FLOATING':
      return AnalyticsType.ANALYTICS_TYPE_TERM_STRUCTURE_FLOATING
    case 8:
    case 'ANALYTICS_TYPE_TERM_STRUCTURE_RICHNESS':
      return AnalyticsType.ANALYTICS_TYPE_TERM_STRUCTURE_RICHNESS
    case 9:
    case 'ANALYTICS_TYPE_VOLATILITY_INDEX':
      return AnalyticsType.ANALYTICS_TYPE_VOLATILITY_INDEX
    case 10:
    case 'ANALYTICS_TYPE_SKEW_CONSTANT':
      return AnalyticsType.ANALYTICS_TYPE_SKEW_CONSTANT
    case 11:
    case 'ANALYTICS_TYPE_SKEW_FLOATING':
      return AnalyticsType.ANALYTICS_TYPE_SKEW_FLOATING
    case 12:
    case 'ANALYTICS_TYPE_USD_GAMMA':
      return AnalyticsType.ANALYTICS_TYPE_USD_GAMMA
    case 13:
    case 'ANALYTICS_TYPE_GEX':
      return AnalyticsType.ANALYTICS_TYPE_GEX
    case 14:
    case 'ANALYTICS_TYPE_VOL_CONES':
      return AnalyticsType.ANALYTICS_TYPE_VOL_CONES
    case 15:
    case 'ANALYTICS_TYPE_RV_SEASONALITY_DOW':
      return AnalyticsType.ANALYTICS_TYPE_RV_SEASONALITY_DOW
    case 16:
    case 'ANALYTICS_TYPE_RV_SEASONALITY_MOY':
      return AnalyticsType.ANALYTICS_TYPE_RV_SEASONALITY_MOY
    case 17:
    case 'ANALYTICS_TYPE_FEDWATCH':
      return AnalyticsType.ANALYTICS_TYPE_FEDWATCH
    case 18:
    case 'ANALYTICS_TYPE_RETURNS_DOW':
      return AnalyticsType.ANALYTICS_TYPE_RETURNS_DOW
    case 19:
    case 'ANALYTICS_TYPE_RETURNS_HOUR':
      return AnalyticsType.ANALYTICS_TYPE_RETURNS_HOUR
    case 20:
    case 'ANALYTICS_TYPE_RETURNS_SESSION':
      return AnalyticsType.ANALYTICS_TYPE_RETURNS_SESSION
    case 21:
    case 'ANALYTICS_TYPE_RETURNS_SESSION_CUMULATIVE':
      return AnalyticsType.ANALYTICS_TYPE_RETURNS_SESSION_CUMULATIVE
    case 22:
    case 'ANALYTICS_TYPE_LIQUIDATION_LEVELS':
      return AnalyticsType.ANALYTICS_TYPE_LIQUIDATION_LEVELS
    case 23:
    case 'ANALYTICS_TYPE_STOP_LEVELS':
      return AnalyticsType.ANALYTICS_TYPE_STOP_LEVELS
    case 24:
    case 'ANALYTICS_TYPE_SVI':
      return AnalyticsType.ANALYTICS_TYPE_SVI
    case 25:
    case 'ANALYTICS_TYPE_RV_SEASONALITY_HOUR':
      return AnalyticsType.ANALYTICS_TYPE_RV_SEASONALITY_HOUR
    case 26:
    case 'ANALYTICS_TYPE_PERP_POSITIONS':
      return AnalyticsType.ANALYTICS_TYPE_PERP_POSITIONS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AnalyticsType.UNRECOGNIZED
  }
}

export function analyticsTypeToJSON(object: AnalyticsType): string {
  switch (object) {
    case AnalyticsType.ANALYTICS_TYPE_UNSPECIFIED:
      return 'ANALYTICS_TYPE_UNSPECIFIED'
    case AnalyticsType.ANALYTICS_TYPE_VOL_METRICS_24HR:
      return 'ANALYTICS_TYPE_VOL_METRICS_24HR'
    case AnalyticsType.ANALYTICS_TYPE_PUT_CALL_RATIO:
      return 'ANALYTICS_TYPE_PUT_CALL_RATIO'
    case AnalyticsType.ANALYTICS_TYPE_DELTA_SURFACE_CONSTANT:
      return 'ANALYTICS_TYPE_DELTA_SURFACE_CONSTANT'
    case AnalyticsType.ANALYTICS_TYPE_DELTA_SURFACE_FLOATING:
      return 'ANALYTICS_TYPE_DELTA_SURFACE_FLOATING'
    case AnalyticsType.ANALYTICS_TYPE_IMPLIED_VS_REALIZED:
      return 'ANALYTICS_TYPE_IMPLIED_VS_REALIZED'
    case AnalyticsType.ANALYTICS_TYPE_TERM_STRUCTURE_CONSTANT:
      return 'ANALYTICS_TYPE_TERM_STRUCTURE_CONSTANT'
    case AnalyticsType.ANALYTICS_TYPE_TERM_STRUCTURE_FLOATING:
      return 'ANALYTICS_TYPE_TERM_STRUCTURE_FLOATING'
    case AnalyticsType.ANALYTICS_TYPE_TERM_STRUCTURE_RICHNESS:
      return 'ANALYTICS_TYPE_TERM_STRUCTURE_RICHNESS'
    case AnalyticsType.ANALYTICS_TYPE_VOLATILITY_INDEX:
      return 'ANALYTICS_TYPE_VOLATILITY_INDEX'
    case AnalyticsType.ANALYTICS_TYPE_SKEW_CONSTANT:
      return 'ANALYTICS_TYPE_SKEW_CONSTANT'
    case AnalyticsType.ANALYTICS_TYPE_SKEW_FLOATING:
      return 'ANALYTICS_TYPE_SKEW_FLOATING'
    case AnalyticsType.ANALYTICS_TYPE_USD_GAMMA:
      return 'ANALYTICS_TYPE_USD_GAMMA'
    case AnalyticsType.ANALYTICS_TYPE_GEX:
      return 'ANALYTICS_TYPE_GEX'
    case AnalyticsType.ANALYTICS_TYPE_VOL_CONES:
      return 'ANALYTICS_TYPE_VOL_CONES'
    case AnalyticsType.ANALYTICS_TYPE_RV_SEASONALITY_DOW:
      return 'ANALYTICS_TYPE_RV_SEASONALITY_DOW'
    case AnalyticsType.ANALYTICS_TYPE_RV_SEASONALITY_MOY:
      return 'ANALYTICS_TYPE_RV_SEASONALITY_MOY'
    case AnalyticsType.ANALYTICS_TYPE_FEDWATCH:
      return 'ANALYTICS_TYPE_FEDWATCH'
    case AnalyticsType.ANALYTICS_TYPE_RETURNS_DOW:
      return 'ANALYTICS_TYPE_RETURNS_DOW'
    case AnalyticsType.ANALYTICS_TYPE_RETURNS_HOUR:
      return 'ANALYTICS_TYPE_RETURNS_HOUR'
    case AnalyticsType.ANALYTICS_TYPE_RETURNS_SESSION:
      return 'ANALYTICS_TYPE_RETURNS_SESSION'
    case AnalyticsType.ANALYTICS_TYPE_RETURNS_SESSION_CUMULATIVE:
      return 'ANALYTICS_TYPE_RETURNS_SESSION_CUMULATIVE'
    case AnalyticsType.ANALYTICS_TYPE_LIQUIDATION_LEVELS:
      return 'ANALYTICS_TYPE_LIQUIDATION_LEVELS'
    case AnalyticsType.ANALYTICS_TYPE_STOP_LEVELS:
      return 'ANALYTICS_TYPE_STOP_LEVELS'
    case AnalyticsType.ANALYTICS_TYPE_SVI:
      return 'ANALYTICS_TYPE_SVI'
    case AnalyticsType.ANALYTICS_TYPE_RV_SEASONALITY_HOUR:
      return 'ANALYTICS_TYPE_RV_SEASONALITY_HOUR'
    case AnalyticsType.ANALYTICS_TYPE_PERP_POSITIONS:
      return 'ANALYTICS_TYPE_PERP_POSITIONS'
    case AnalyticsType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Exhange Data type */
export enum ExchangeDataType {
  EXCHANGE_DATA_TYPE_UNSPECIFIED = 0,
  EXCHANGE_DATA_TYPE_INSTRUMENTS = 1,
  UNRECOGNIZED = -1,
}

export function exchangeDataTypeFromJSON(object: any): ExchangeDataType {
  switch (object) {
    case 0:
    case 'EXCHANGE_DATA_TYPE_UNSPECIFIED':
      return ExchangeDataType.EXCHANGE_DATA_TYPE_UNSPECIFIED
    case 1:
    case 'EXCHANGE_DATA_TYPE_INSTRUMENTS':
      return ExchangeDataType.EXCHANGE_DATA_TYPE_INSTRUMENTS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ExchangeDataType.UNRECOGNIZED
  }
}

export function exchangeDataTypeToJSON(object: ExchangeDataType): string {
  switch (object) {
    case ExchangeDataType.EXCHANGE_DATA_TYPE_UNSPECIFIED:
      return 'EXCHANGE_DATA_TYPE_UNSPECIFIED'
    case ExchangeDataType.EXCHANGE_DATA_TYPE_INSTRUMENTS:
      return 'EXCHANGE_DATA_TYPE_INSTRUMENTS'
    case ExchangeDataType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Account Data type */
export enum AccountDataType {
  ACCOUNT_DATA_TYPE_UNSPECIFIED = 0,
  ACCOUNT_DATA_TYPE_PORTFOLIO = 1,
  ACCOUNT_DATA_TYPE_POSITIONS = 2,
  UNRECOGNIZED = -1,
}

export function accountDataTypeFromJSON(object: any): AccountDataType {
  switch (object) {
    case 0:
    case 'ACCOUNT_DATA_TYPE_UNSPECIFIED':
      return AccountDataType.ACCOUNT_DATA_TYPE_UNSPECIFIED
    case 1:
    case 'ACCOUNT_DATA_TYPE_PORTFOLIO':
      return AccountDataType.ACCOUNT_DATA_TYPE_PORTFOLIO
    case 2:
    case 'ACCOUNT_DATA_TYPE_POSITIONS':
      return AccountDataType.ACCOUNT_DATA_TYPE_POSITIONS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AccountDataType.UNRECOGNIZED
  }
}

export function accountDataTypeToJSON(object: AccountDataType): string {
  switch (object) {
    case AccountDataType.ACCOUNT_DATA_TYPE_UNSPECIFIED:
      return 'ACCOUNT_DATA_TYPE_UNSPECIFIED'
    case AccountDataType.ACCOUNT_DATA_TYPE_PORTFOLIO:
      return 'ACCOUNT_DATA_TYPE_PORTFOLIO'
    case AccountDataType.ACCOUNT_DATA_TYPE_POSITIONS:
      return 'ACCOUNT_DATA_TYPE_POSITIONS'
    case AccountDataType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Account Data Stream type */
export enum AccountDataStreamType {
  ACCOUNT_DATA_STREAM_TYPE_UNSPECIFIED = 0,
  ACCOUNT_DATA_STREAM_TYPE_POSITIONS = 1,
  ACCOUNT_DATA_STREAM_TYPE_ORDERS = 2,
  ACCOUNT_DATA_STREAM_TYPE_TRADES = 3,
  ACCOUNT_DATA_STREAM_TYPE_UPDATES = 4,
  ACCOUNT_DATA_STREAM_TYPE_PORTFOLIO = 5,
  ACCOUNT_DATA_STREAM_TYPE_NOTIFICATIONS = 6,
  ACCOUNT_DATA_STREAM_TYPE_RFQS = 7,
  ACCOUNT_DATA_STREAM_TYPE_FEES = 8,
  ACCOUNT_DATA_STREAM_TYPE_SUMMARY = 9,
  ACCOUNT_DATA_STREAM_TYPE_TRANSFERS = 10,
  /**
   * ACCOUNT_DATA_STREAM_TYPE_RFQ_MAKER - Incoming RFQs (as maker) + this account's maker quotes. Payloads
   * DataPayload.rfq_maker_rfqs / rfq_maker_quotes. Separate from RFQS on
   * purpose: taker frames feed rfq_events, the RFQ algo and analytics.
   */
  ACCOUNT_DATA_STREAM_TYPE_RFQ_MAKER = 11,
  UNRECOGNIZED = -1,
}

export function accountDataStreamTypeFromJSON(object: any): AccountDataStreamType {
  switch (object) {
    case 0:
    case 'ACCOUNT_DATA_STREAM_TYPE_UNSPECIFIED':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_UNSPECIFIED
    case 1:
    case 'ACCOUNT_DATA_STREAM_TYPE_POSITIONS':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_POSITIONS
    case 2:
    case 'ACCOUNT_DATA_STREAM_TYPE_ORDERS':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_ORDERS
    case 3:
    case 'ACCOUNT_DATA_STREAM_TYPE_TRADES':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_TRADES
    case 4:
    case 'ACCOUNT_DATA_STREAM_TYPE_UPDATES':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_UPDATES
    case 5:
    case 'ACCOUNT_DATA_STREAM_TYPE_PORTFOLIO':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_PORTFOLIO
    case 6:
    case 'ACCOUNT_DATA_STREAM_TYPE_NOTIFICATIONS':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_NOTIFICATIONS
    case 7:
    case 'ACCOUNT_DATA_STREAM_TYPE_RFQS':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_RFQS
    case 8:
    case 'ACCOUNT_DATA_STREAM_TYPE_FEES':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_FEES
    case 9:
    case 'ACCOUNT_DATA_STREAM_TYPE_SUMMARY':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_SUMMARY
    case 10:
    case 'ACCOUNT_DATA_STREAM_TYPE_TRANSFERS':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_TRANSFERS
    case 11:
    case 'ACCOUNT_DATA_STREAM_TYPE_RFQ_MAKER':
      return AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_RFQ_MAKER
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AccountDataStreamType.UNRECOGNIZED
  }
}

export function accountDataStreamTypeToJSON(object: AccountDataStreamType): string {
  switch (object) {
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_UNSPECIFIED:
      return 'ACCOUNT_DATA_STREAM_TYPE_UNSPECIFIED'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_POSITIONS:
      return 'ACCOUNT_DATA_STREAM_TYPE_POSITIONS'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_ORDERS:
      return 'ACCOUNT_DATA_STREAM_TYPE_ORDERS'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_TRADES:
      return 'ACCOUNT_DATA_STREAM_TYPE_TRADES'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_UPDATES:
      return 'ACCOUNT_DATA_STREAM_TYPE_UPDATES'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_PORTFOLIO:
      return 'ACCOUNT_DATA_STREAM_TYPE_PORTFOLIO'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_NOTIFICATIONS:
      return 'ACCOUNT_DATA_STREAM_TYPE_NOTIFICATIONS'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_RFQS:
      return 'ACCOUNT_DATA_STREAM_TYPE_RFQS'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_FEES:
      return 'ACCOUNT_DATA_STREAM_TYPE_FEES'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_SUMMARY:
      return 'ACCOUNT_DATA_STREAM_TYPE_SUMMARY'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_TRANSFERS:
      return 'ACCOUNT_DATA_STREAM_TYPE_TRANSFERS'
    case AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_RFQ_MAKER:
      return 'ACCOUNT_DATA_STREAM_TYPE_RFQ_MAKER'
    case AccountDataStreamType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** Order book related types */
export enum BookAction {
  BOOK_ACTION_UNSPECIFIED = 0,
  BOOK_ACTION_NEW = 1,
  BOOK_ACTION_CHANGE = 2,
  BOOK_ACTION_DELETE = 3,
  UNRECOGNIZED = -1,
}

export function bookActionFromJSON(object: any): BookAction {
  switch (object) {
    case 0:
    case 'BOOK_ACTION_UNSPECIFIED':
      return BookAction.BOOK_ACTION_UNSPECIFIED
    case 1:
    case 'BOOK_ACTION_NEW':
      return BookAction.BOOK_ACTION_NEW
    case 2:
    case 'BOOK_ACTION_CHANGE':
      return BookAction.BOOK_ACTION_CHANGE
    case 3:
    case 'BOOK_ACTION_DELETE':
      return BookAction.BOOK_ACTION_DELETE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return BookAction.UNRECOGNIZED
  }
}

export function bookActionToJSON(object: BookAction): string {
  switch (object) {
    case BookAction.BOOK_ACTION_UNSPECIFIED:
      return 'BOOK_ACTION_UNSPECIFIED'
    case BookAction.BOOK_ACTION_NEW:
      return 'BOOK_ACTION_NEW'
    case BookAction.BOOK_ACTION_CHANGE:
      return 'BOOK_ACTION_CHANGE'
    case BookAction.BOOK_ACTION_DELETE:
      return 'BOOK_ACTION_DELETE'
    case BookAction.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum OptionType {
  OPTION_TYPE_UNSPECIFIED = 0,
  OPTION_TYPE_CALL = 1,
  OPTION_TYPE_PUT = 2,
  UNRECOGNIZED = -1,
}

export function optionTypeFromJSON(object: any): OptionType {
  switch (object) {
    case 0:
    case 'OPTION_TYPE_UNSPECIFIED':
      return OptionType.OPTION_TYPE_UNSPECIFIED
    case 1:
    case 'OPTION_TYPE_CALL':
      return OptionType.OPTION_TYPE_CALL
    case 2:
    case 'OPTION_TYPE_PUT':
      return OptionType.OPTION_TYPE_PUT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OptionType.UNRECOGNIZED
  }
}

export function optionTypeToJSON(object: OptionType): string {
  switch (object) {
    case OptionType.OPTION_TYPE_UNSPECIFIED:
      return 'OPTION_TYPE_UNSPECIFIED'
    case OptionType.OPTION_TYPE_CALL:
      return 'OPTION_TYPE_CALL'
    case OptionType.OPTION_TYPE_PUT:
      return 'OPTION_TYPE_PUT'
    case OptionType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Bar width on the chart grid, shared by every chart-family request,
 * response and stream. Each value IS the width in seconds, so a field typed
 * `ChartTimeframe` is byte-identical on the wire to the `int32` seconds it
 * replaced; clients that still send plain seconds keep working.
 *
 * Buckets align to QuestDB's calendar: SEC_1..DAY_3 on the epoch, WEEK_1 on
 * ISO Monday, MONTH_1 on the 1st of each calendar month (its value, 30 days,
 * is a label only, never a bar width; a bar runs 28-31 days).
 * Anything else, UNSPECIFIED included, is rejected with a 400.
 */
export enum ChartTimeframe {
  CHART_TIMEFRAME_UNSPECIFIED = 0,
  CHART_TIMEFRAME_SEC_1 = 1,
  CHART_TIMEFRAME_SEC_15 = 15,
  CHART_TIMEFRAME_MIN_1 = 60,
  CHART_TIMEFRAME_MIN_5 = 300,
  CHART_TIMEFRAME_MIN_15 = 900,
  CHART_TIMEFRAME_MIN_30 = 1800,
  CHART_TIMEFRAME_HOUR_1 = 3600,
  CHART_TIMEFRAME_HOUR_2 = 7200,
  CHART_TIMEFRAME_HOUR_4 = 14400,
  CHART_TIMEFRAME_HOUR_8 = 28800,
  CHART_TIMEFRAME_HOUR_12 = 43200,
  CHART_TIMEFRAME_DAY_1 = 86400,
  CHART_TIMEFRAME_DAY_3 = 259200,
  CHART_TIMEFRAME_WEEK_1 = 604800,
  CHART_TIMEFRAME_MONTH_1 = 2592000,
  UNRECOGNIZED = -1,
}

export function chartTimeframeFromJSON(object: any): ChartTimeframe {
  switch (object) {
    case 0:
    case 'CHART_TIMEFRAME_UNSPECIFIED':
      return ChartTimeframe.CHART_TIMEFRAME_UNSPECIFIED
    case 1:
    case 'CHART_TIMEFRAME_SEC_1':
      return ChartTimeframe.CHART_TIMEFRAME_SEC_1
    case 15:
    case 'CHART_TIMEFRAME_SEC_15':
      return ChartTimeframe.CHART_TIMEFRAME_SEC_15
    case 60:
    case 'CHART_TIMEFRAME_MIN_1':
      return ChartTimeframe.CHART_TIMEFRAME_MIN_1
    case 300:
    case 'CHART_TIMEFRAME_MIN_5':
      return ChartTimeframe.CHART_TIMEFRAME_MIN_5
    case 900:
    case 'CHART_TIMEFRAME_MIN_15':
      return ChartTimeframe.CHART_TIMEFRAME_MIN_15
    case 1800:
    case 'CHART_TIMEFRAME_MIN_30':
      return ChartTimeframe.CHART_TIMEFRAME_MIN_30
    case 3600:
    case 'CHART_TIMEFRAME_HOUR_1':
      return ChartTimeframe.CHART_TIMEFRAME_HOUR_1
    case 7200:
    case 'CHART_TIMEFRAME_HOUR_2':
      return ChartTimeframe.CHART_TIMEFRAME_HOUR_2
    case 14400:
    case 'CHART_TIMEFRAME_HOUR_4':
      return ChartTimeframe.CHART_TIMEFRAME_HOUR_4
    case 28800:
    case 'CHART_TIMEFRAME_HOUR_8':
      return ChartTimeframe.CHART_TIMEFRAME_HOUR_8
    case 43200:
    case 'CHART_TIMEFRAME_HOUR_12':
      return ChartTimeframe.CHART_TIMEFRAME_HOUR_12
    case 86400:
    case 'CHART_TIMEFRAME_DAY_1':
      return ChartTimeframe.CHART_TIMEFRAME_DAY_1
    case 259200:
    case 'CHART_TIMEFRAME_DAY_3':
      return ChartTimeframe.CHART_TIMEFRAME_DAY_3
    case 604800:
    case 'CHART_TIMEFRAME_WEEK_1':
      return ChartTimeframe.CHART_TIMEFRAME_WEEK_1
    case 2592000:
    case 'CHART_TIMEFRAME_MONTH_1':
      return ChartTimeframe.CHART_TIMEFRAME_MONTH_1
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ChartTimeframe.UNRECOGNIZED
  }
}

export function chartTimeframeToJSON(object: ChartTimeframe): string {
  switch (object) {
    case ChartTimeframe.CHART_TIMEFRAME_UNSPECIFIED:
      return 'CHART_TIMEFRAME_UNSPECIFIED'
    case ChartTimeframe.CHART_TIMEFRAME_SEC_1:
      return 'CHART_TIMEFRAME_SEC_1'
    case ChartTimeframe.CHART_TIMEFRAME_SEC_15:
      return 'CHART_TIMEFRAME_SEC_15'
    case ChartTimeframe.CHART_TIMEFRAME_MIN_1:
      return 'CHART_TIMEFRAME_MIN_1'
    case ChartTimeframe.CHART_TIMEFRAME_MIN_5:
      return 'CHART_TIMEFRAME_MIN_5'
    case ChartTimeframe.CHART_TIMEFRAME_MIN_15:
      return 'CHART_TIMEFRAME_MIN_15'
    case ChartTimeframe.CHART_TIMEFRAME_MIN_30:
      return 'CHART_TIMEFRAME_MIN_30'
    case ChartTimeframe.CHART_TIMEFRAME_HOUR_1:
      return 'CHART_TIMEFRAME_HOUR_1'
    case ChartTimeframe.CHART_TIMEFRAME_HOUR_2:
      return 'CHART_TIMEFRAME_HOUR_2'
    case ChartTimeframe.CHART_TIMEFRAME_HOUR_4:
      return 'CHART_TIMEFRAME_HOUR_4'
    case ChartTimeframe.CHART_TIMEFRAME_HOUR_8:
      return 'CHART_TIMEFRAME_HOUR_8'
    case ChartTimeframe.CHART_TIMEFRAME_HOUR_12:
      return 'CHART_TIMEFRAME_HOUR_12'
    case ChartTimeframe.CHART_TIMEFRAME_DAY_1:
      return 'CHART_TIMEFRAME_DAY_1'
    case ChartTimeframe.CHART_TIMEFRAME_DAY_3:
      return 'CHART_TIMEFRAME_DAY_3'
    case ChartTimeframe.CHART_TIMEFRAME_WEEK_1:
      return 'CHART_TIMEFRAME_WEEK_1'
    case ChartTimeframe.CHART_TIMEFRAME_MONTH_1:
      return 'CHART_TIMEFRAME_MONTH_1'
    case ChartTimeframe.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * How an option may be exercised. Set on options only; absent on every other
 * kind. UNSPECIFIED on an option means the venue's catalogue did not say, and
 * such an option is excluded from every fit (vol-fit `exercise_style_unknown`).
 */
export enum ExerciseStyle {
  EXERCISE_STYLE_UNSPECIFIED = 0,
  EXERCISE_STYLE_AMERICAN = 1,
  EXERCISE_STYLE_EUROPEAN = 2,
  EXERCISE_STYLE_BERMUDAN = 3,
  UNRECOGNIZED = -1,
}

export function exerciseStyleFromJSON(object: any): ExerciseStyle {
  switch (object) {
    case 0:
    case 'EXERCISE_STYLE_UNSPECIFIED':
      return ExerciseStyle.EXERCISE_STYLE_UNSPECIFIED
    case 1:
    case 'EXERCISE_STYLE_AMERICAN':
      return ExerciseStyle.EXERCISE_STYLE_AMERICAN
    case 2:
    case 'EXERCISE_STYLE_EUROPEAN':
      return ExerciseStyle.EXERCISE_STYLE_EUROPEAN
    case 3:
    case 'EXERCISE_STYLE_BERMUDAN':
      return ExerciseStyle.EXERCISE_STYLE_BERMUDAN
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ExerciseStyle.UNRECOGNIZED
  }
}

export function exerciseStyleToJSON(object: ExerciseStyle): string {
  switch (object) {
    case ExerciseStyle.EXERCISE_STYLE_UNSPECIFIED:
      return 'EXERCISE_STYLE_UNSPECIFIED'
    case ExerciseStyle.EXERCISE_STYLE_AMERICAN:
      return 'EXERCISE_STYLE_AMERICAN'
    case ExerciseStyle.EXERCISE_STYLE_EUROPEAN:
      return 'EXERCISE_STYLE_EUROPEAN'
    case ExerciseStyle.EXERCISE_STYLE_BERMUDAN:
      return 'EXERCISE_STYLE_BERMUDAN'
    case ExerciseStyle.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Canonical price-axis reference. Used by anything that needs to anchor or
 * compare against a specific price stream — limit-price relative anchors,
 * trigger price conditions, etc. Single source of truth so intent_compiler,
 * triggers, and any future consumer agree on the value set.
 */
export enum PriceReference {
  PRICE_REFERENCE_UNSPECIFIED = 0,
  PRICE_REFERENCE_BEST_BID = 1,
  PRICE_REFERENCE_BEST_ASK = 2,
  PRICE_REFERENCE_MID_PRICE = 3,
  PRICE_REFERENCE_MARK_PRICE = 4,
  PRICE_REFERENCE_LAST_PRICE = 5,
  PRICE_REFERENCE_INDEX_PRICE = 6,
  UNRECOGNIZED = -1,
}

export function priceReferenceFromJSON(object: any): PriceReference {
  switch (object) {
    case 0:
    case 'PRICE_REFERENCE_UNSPECIFIED':
      return PriceReference.PRICE_REFERENCE_UNSPECIFIED
    case 1:
    case 'PRICE_REFERENCE_BEST_BID':
      return PriceReference.PRICE_REFERENCE_BEST_BID
    case 2:
    case 'PRICE_REFERENCE_BEST_ASK':
      return PriceReference.PRICE_REFERENCE_BEST_ASK
    case 3:
    case 'PRICE_REFERENCE_MID_PRICE':
      return PriceReference.PRICE_REFERENCE_MID_PRICE
    case 4:
    case 'PRICE_REFERENCE_MARK_PRICE':
      return PriceReference.PRICE_REFERENCE_MARK_PRICE
    case 5:
    case 'PRICE_REFERENCE_LAST_PRICE':
      return PriceReference.PRICE_REFERENCE_LAST_PRICE
    case 6:
    case 'PRICE_REFERENCE_INDEX_PRICE':
      return PriceReference.PRICE_REFERENCE_INDEX_PRICE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PriceReference.UNRECOGNIZED
  }
}

export function priceReferenceToJSON(object: PriceReference): string {
  switch (object) {
    case PriceReference.PRICE_REFERENCE_UNSPECIFIED:
      return 'PRICE_REFERENCE_UNSPECIFIED'
    case PriceReference.PRICE_REFERENCE_BEST_BID:
      return 'PRICE_REFERENCE_BEST_BID'
    case PriceReference.PRICE_REFERENCE_BEST_ASK:
      return 'PRICE_REFERENCE_BEST_ASK'
    case PriceReference.PRICE_REFERENCE_MID_PRICE:
      return 'PRICE_REFERENCE_MID_PRICE'
    case PriceReference.PRICE_REFERENCE_MARK_PRICE:
      return 'PRICE_REFERENCE_MARK_PRICE'
    case PriceReference.PRICE_REFERENCE_LAST_PRICE:
      return 'PRICE_REFERENCE_LAST_PRICE'
    case PriceReference.PRICE_REFERENCE_INDEX_PRICE:
      return 'PRICE_REFERENCE_INDEX_PRICE'
    case PriceReference.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum Liquidation {
  LIQUIDATION_UNSPECIFIED = 0,
  LIQUIDATION_M = 1,
  LIQUIDATION_T = 2,
  LIQUIDATION_MT = 3,
  UNRECOGNIZED = -1,
}

export function liquidationFromJSON(object: any): Liquidation {
  switch (object) {
    case 0:
    case 'LIQUIDATION_UNSPECIFIED':
      return Liquidation.LIQUIDATION_UNSPECIFIED
    case 1:
    case 'LIQUIDATION_M':
      return Liquidation.LIQUIDATION_M
    case 2:
    case 'LIQUIDATION_T':
      return Liquidation.LIQUIDATION_T
    case 3:
    case 'LIQUIDATION_MT':
      return Liquidation.LIQUIDATION_MT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return Liquidation.UNRECOGNIZED
  }
}

export function liquidationToJSON(object: Liquidation): string {
  switch (object) {
    case Liquidation.LIQUIDATION_UNSPECIFIED:
      return 'LIQUIDATION_UNSPECIFIED'
    case Liquidation.LIQUIDATION_M:
      return 'LIQUIDATION_M'
    case Liquidation.LIQUIDATION_T:
      return 'LIQUIDATION_T'
    case Liquidation.LIQUIDATION_MT:
      return 'LIQUIDATION_MT'
    case Liquidation.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * How margin is POOLED. Account-level on PortfolioData; per-position on
 * Position, where a venue lets one position ring-fence its own margin.
 * UNSPECIFIED means the venue doesn't report it (or has no margin at all) —
 * render it as blank, never as CROSS.
 */
export enum MarginScope {
  MARGIN_SCOPE_UNSPECIFIED = 0,
  /** MARGIN_SCOPE_CROSS - One collateral pool backs every position. */
  MARGIN_SCOPE_CROSS = 1,
  /**
   * MARGIN_SCOPE_ISOLATED - Margin is ring-fenced: Deribit `segregated_*` (per settlement currency),
   * Bybit ISOLATED_MARGIN, a Hyperliquid or Lighter isolated position.
   */
  MARGIN_SCOPE_ISOLATED = 2,
  UNRECOGNIZED = -1,
}

export function marginScopeFromJSON(object: any): MarginScope {
  switch (object) {
    case 0:
    case 'MARGIN_SCOPE_UNSPECIFIED':
      return MarginScope.MARGIN_SCOPE_UNSPECIFIED
    case 1:
    case 'MARGIN_SCOPE_CROSS':
      return MarginScope.MARGIN_SCOPE_CROSS
    case 2:
    case 'MARGIN_SCOPE_ISOLATED':
      return MarginScope.MARGIN_SCOPE_ISOLATED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MarginScope.UNRECOGNIZED
  }
}

export function marginScopeToJSON(object: MarginScope): string {
  switch (object) {
    case MarginScope.MARGIN_SCOPE_UNSPECIFIED:
      return 'MARGIN_SCOPE_UNSPECIFIED'
    case MarginScope.MARGIN_SCOPE_CROSS:
      return 'MARGIN_SCOPE_CROSS'
    case MarginScope.MARGIN_SCOPE_ISOLATED:
      return 'MARGIN_SCOPE_ISOLATED'
    case MarginScope.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * How the venue COMPUTES the requirement. Orthogonal to MarginScope — Deribit's
 * model names are the cross product of the two (`cross_pm`, `segregated_sm`).
 */
export enum MarginMethod {
  MARGIN_METHOD_UNSPECIFIED = 0,
  /**
   * MARGIN_METHOD_STANDARD - Per-position tiered/linear rules: Deribit `*_sm`, Bybit REGULAR and
   * ISOLATED, Derive SM.
   */
  MARGIN_METHOD_STANDARD = 1,
  /**
   * MARGIN_METHOD_PORTFOLIO - Account-wide risk model: Deribit `*_pm`, Bybit PORTFOLIO_MARGIN,
   * Derive PM and PM2.
   */
  MARGIN_METHOD_PORTFOLIO = 2,
  /** MARGIN_METHOD_SPAN - SPAN-style scenario margining: Deribit `cross_spm_v3`. */
  MARGIN_METHOD_SPAN = 3,
  UNRECOGNIZED = -1,
}

export function marginMethodFromJSON(object: any): MarginMethod {
  switch (object) {
    case 0:
    case 'MARGIN_METHOD_UNSPECIFIED':
      return MarginMethod.MARGIN_METHOD_UNSPECIFIED
    case 1:
    case 'MARGIN_METHOD_STANDARD':
      return MarginMethod.MARGIN_METHOD_STANDARD
    case 2:
    case 'MARGIN_METHOD_PORTFOLIO':
      return MarginMethod.MARGIN_METHOD_PORTFOLIO
    case 3:
    case 'MARGIN_METHOD_SPAN':
      return MarginMethod.MARGIN_METHOD_SPAN
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MarginMethod.UNRECOGNIZED
  }
}

export function marginMethodToJSON(object: MarginMethod): string {
  switch (object) {
    case MarginMethod.MARGIN_METHOD_UNSPECIFIED:
      return 'MARGIN_METHOD_UNSPECIFIED'
    case MarginMethod.MARGIN_METHOD_STANDARD:
      return 'MARGIN_METHOD_STANDARD'
    case MarginMethod.MARGIN_METHOD_PORTFOLIO:
      return 'MARGIN_METHOD_PORTFOLIO'
    case MarginMethod.MARGIN_METHOD_SPAN:
      return 'MARGIN_METHOD_SPAN'
    case MarginMethod.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AssetClass {
  ASSET_CLASS_UNSPECIFIED = 0,
  ASSET_CLASS_CRYPTO = 1,
  ASSET_CLASS_EQUITY = 2,
  ASSET_CLASS_COMMODITY = 3,
  ASSET_CLASS_FX = 4,
  ASSET_CLASS_INDEX = 5,
  ASSET_CLASS_RATE = 6,
  UNRECOGNIZED = -1,
}

export function assetClassFromJSON(object: any): AssetClass {
  switch (object) {
    case 0:
    case 'ASSET_CLASS_UNSPECIFIED':
      return AssetClass.ASSET_CLASS_UNSPECIFIED
    case 1:
    case 'ASSET_CLASS_CRYPTO':
      return AssetClass.ASSET_CLASS_CRYPTO
    case 2:
    case 'ASSET_CLASS_EQUITY':
      return AssetClass.ASSET_CLASS_EQUITY
    case 3:
    case 'ASSET_CLASS_COMMODITY':
      return AssetClass.ASSET_CLASS_COMMODITY
    case 4:
    case 'ASSET_CLASS_FX':
      return AssetClass.ASSET_CLASS_FX
    case 5:
    case 'ASSET_CLASS_INDEX':
      return AssetClass.ASSET_CLASS_INDEX
    case 6:
    case 'ASSET_CLASS_RATE':
      return AssetClass.ASSET_CLASS_RATE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AssetClass.UNRECOGNIZED
  }
}

export function assetClassToJSON(object: AssetClass): string {
  switch (object) {
    case AssetClass.ASSET_CLASS_UNSPECIFIED:
      return 'ASSET_CLASS_UNSPECIFIED'
    case AssetClass.ASSET_CLASS_CRYPTO:
      return 'ASSET_CLASS_CRYPTO'
    case AssetClass.ASSET_CLASS_EQUITY:
      return 'ASSET_CLASS_EQUITY'
    case AssetClass.ASSET_CLASS_COMMODITY:
      return 'ASSET_CLASS_COMMODITY'
    case AssetClass.ASSET_CLASS_FX:
      return 'ASSET_CLASS_FX'
    case AssetClass.ASSET_CLASS_INDEX:
      return 'ASSET_CLASS_INDEX'
    case AssetClass.ASSET_CLASS_RATE:
      return 'ASSET_CLASS_RATE'
    case AssetClass.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum EnrichmentStatus {
  ENRICHMENT_STATUS_UNSPECIFIED = 0,
  ENRICHMENT_STATUS_FILLED = 1,
  ENRICHMENT_STATUS_DRAFT = 2,
  ENRICHMENT_STATUS_UNFILLED = 3,
  UNRECOGNIZED = -1,
}

export function enrichmentStatusFromJSON(object: any): EnrichmentStatus {
  switch (object) {
    case 0:
    case 'ENRICHMENT_STATUS_UNSPECIFIED':
      return EnrichmentStatus.ENRICHMENT_STATUS_UNSPECIFIED
    case 1:
    case 'ENRICHMENT_STATUS_FILLED':
      return EnrichmentStatus.ENRICHMENT_STATUS_FILLED
    case 2:
    case 'ENRICHMENT_STATUS_DRAFT':
      return EnrichmentStatus.ENRICHMENT_STATUS_DRAFT
    case 3:
    case 'ENRICHMENT_STATUS_UNFILLED':
      return EnrichmentStatus.ENRICHMENT_STATUS_UNFILLED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EnrichmentStatus.UNRECOGNIZED
  }
}

export function enrichmentStatusToJSON(object: EnrichmentStatus): string {
  switch (object) {
    case EnrichmentStatus.ENRICHMENT_STATUS_UNSPECIFIED:
      return 'ENRICHMENT_STATUS_UNSPECIFIED'
    case EnrichmentStatus.ENRICHMENT_STATUS_FILLED:
      return 'ENRICHMENT_STATUS_FILLED'
    case EnrichmentStatus.ENRICHMENT_STATUS_DRAFT:
      return 'ENRICHMENT_STATUS_DRAFT'
    case EnrichmentStatus.ENRICHMENT_STATUS_UNFILLED:
      return 'ENRICHMENT_STATUS_UNFILLED'
    case EnrichmentStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum EnrichmentSource {
  ENRICHMENT_SOURCE_UNSPECIFIED = 0,
  ENRICHMENT_SOURCE_DETERMINISTIC = 1,
  ENRICHMENT_SOURCE_AI = 2,
  ENRICHMENT_SOURCE_CURATED = 3,
  UNRECOGNIZED = -1,
}

export function enrichmentSourceFromJSON(object: any): EnrichmentSource {
  switch (object) {
    case 0:
    case 'ENRICHMENT_SOURCE_UNSPECIFIED':
      return EnrichmentSource.ENRICHMENT_SOURCE_UNSPECIFIED
    case 1:
    case 'ENRICHMENT_SOURCE_DETERMINISTIC':
      return EnrichmentSource.ENRICHMENT_SOURCE_DETERMINISTIC
    case 2:
    case 'ENRICHMENT_SOURCE_AI':
      return EnrichmentSource.ENRICHMENT_SOURCE_AI
    case 3:
    case 'ENRICHMENT_SOURCE_CURATED':
      return EnrichmentSource.ENRICHMENT_SOURCE_CURATED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EnrichmentSource.UNRECOGNIZED
  }
}

export function enrichmentSourceToJSON(object: EnrichmentSource): string {
  switch (object) {
    case EnrichmentSource.ENRICHMENT_SOURCE_UNSPECIFIED:
      return 'ENRICHMENT_SOURCE_UNSPECIFIED'
    case EnrichmentSource.ENRICHMENT_SOURCE_DETERMINISTIC:
      return 'ENRICHMENT_SOURCE_DETERMINISTIC'
    case EnrichmentSource.ENRICHMENT_SOURCE_AI:
      return 'ENRICHMENT_SOURCE_AI'
    case EnrichmentSource.ENRICHMENT_SOURCE_CURATED:
      return 'ENRICHMENT_SOURCE_CURATED'
    case EnrichmentSource.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum UpdateType {
  UPDATE_TYPE_UNSPECIFIED = 0,
  UPDATE_TYPE_SNAPSHOT = 1,
  UPDATE_TYPE_CHANGE = 2,
  UNRECOGNIZED = -1,
}

export function updateTypeFromJSON(object: any): UpdateType {
  switch (object) {
    case 0:
    case 'UPDATE_TYPE_UNSPECIFIED':
      return UpdateType.UPDATE_TYPE_UNSPECIFIED
    case 1:
    case 'UPDATE_TYPE_SNAPSHOT':
      return UpdateType.UPDATE_TYPE_SNAPSHOT
    case 2:
    case 'UPDATE_TYPE_CHANGE':
      return UpdateType.UPDATE_TYPE_CHANGE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return UpdateType.UNRECOGNIZED
  }
}

export function updateTypeToJSON(object: UpdateType): string {
  switch (object) {
    case UpdateType.UPDATE_TYPE_UNSPECIFIED:
      return 'UPDATE_TYPE_UNSPECIFIED'
    case UpdateType.UPDATE_TYPE_SNAPSHOT:
      return 'UPDATE_TYPE_SNAPSHOT'
    case UpdateType.UPDATE_TYPE_CHANGE:
      return 'UPDATE_TYPE_CHANGE'
    case UpdateType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum InstrumentStateType {
  INSTRUMENT_STATE_TYPE_UNSPECIFIED = 0,
  INSTRUMENT_STATE_TYPE_OPEN = 1,
  INSTRUMENT_STATE_TYPE_SETTLEMENT = 2,
  INSTRUMENT_STATE_TYPE_DELIVERED = 3,
  INSTRUMENT_STATE_TYPE_INACTIVE = 4,
  INSTRUMENT_STATE_TYPE_LOCKED = 5,
  INSTRUMENT_STATE_TYPE_HALTED = 6,
  INSTRUMENT_STATE_TYPE_ARCHIVIZED = 7,
  /**
   * INSTRUMENT_STATE_TYPE_PRE_OPEN - Not trading because the session has not opened yet (CME `Status`:
   * is_trading = N, action PreOpen). Every other non-trading CME action that
   * is not a close (halt, pause, suspend, pre-close, ...) is HALTED.
   */
  INSTRUMENT_STATE_TYPE_PRE_OPEN = 8,
  /**
   * INSTRUMENT_STATE_TYPE_CLOSED - Not trading because the session has closed (CME `Status`: is_trading =
   * N, action Close or PostClose).
   */
  INSTRUMENT_STATE_TYPE_CLOSED = 9,
  UNRECOGNIZED = -1,
}

export function instrumentStateTypeFromJSON(object: any): InstrumentStateType {
  switch (object) {
    case 0:
    case 'INSTRUMENT_STATE_TYPE_UNSPECIFIED':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_UNSPECIFIED
    case 1:
    case 'INSTRUMENT_STATE_TYPE_OPEN':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_OPEN
    case 2:
    case 'INSTRUMENT_STATE_TYPE_SETTLEMENT':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_SETTLEMENT
    case 3:
    case 'INSTRUMENT_STATE_TYPE_DELIVERED':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_DELIVERED
    case 4:
    case 'INSTRUMENT_STATE_TYPE_INACTIVE':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_INACTIVE
    case 5:
    case 'INSTRUMENT_STATE_TYPE_LOCKED':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_LOCKED
    case 6:
    case 'INSTRUMENT_STATE_TYPE_HALTED':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_HALTED
    case 7:
    case 'INSTRUMENT_STATE_TYPE_ARCHIVIZED':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_ARCHIVIZED
    case 8:
    case 'INSTRUMENT_STATE_TYPE_PRE_OPEN':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_PRE_OPEN
    case 9:
    case 'INSTRUMENT_STATE_TYPE_CLOSED':
      return InstrumentStateType.INSTRUMENT_STATE_TYPE_CLOSED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return InstrumentStateType.UNRECOGNIZED
  }
}

export function instrumentStateTypeToJSON(object: InstrumentStateType): string {
  switch (object) {
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_UNSPECIFIED:
      return 'INSTRUMENT_STATE_TYPE_UNSPECIFIED'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_OPEN:
      return 'INSTRUMENT_STATE_TYPE_OPEN'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_SETTLEMENT:
      return 'INSTRUMENT_STATE_TYPE_SETTLEMENT'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_DELIVERED:
      return 'INSTRUMENT_STATE_TYPE_DELIVERED'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_INACTIVE:
      return 'INSTRUMENT_STATE_TYPE_INACTIVE'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_LOCKED:
      return 'INSTRUMENT_STATE_TYPE_LOCKED'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_HALTED:
      return 'INSTRUMENT_STATE_TYPE_HALTED'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_ARCHIVIZED:
      return 'INSTRUMENT_STATE_TYPE_ARCHIVIZED'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_PRE_OPEN:
      return 'INSTRUMENT_STATE_TYPE_PRE_OPEN'
    case InstrumentStateType.INSTRUMENT_STATE_TYPE_CLOSED:
      return 'INSTRUMENT_STATE_TYPE_CLOSED'
    case InstrumentStateType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export interface BookEntry {
  action?: BookAction | undefined
  /** Decimal as string */
  price: string
  /** Decimal as string */
  quantity: string
}

export interface OrderBook {
  symbol: string
  exchange: Exchange
  bids: BookEntry[]
  asks: BookEntry[]
  /** Unix timestamp in nanoseconds */
  timestamp: string
  type: UpdateType
  changeId: string
  prevChangeId?: string | undefined
  /**
   * (bid_qty − ask_qty) / (bid_qty + ask_qty) over the top
   * imbalance_depth_limit levels (or all visible if 0). Range [-1, +1];
   * -1 = 100% asks, +1 = 100% bids.
   */
  imbalanceRatio?: string | undefined
  /** Order-book event count over the trailing update_rate_window_ms window. */
  updateRateHz?: number | undefined
  /**
   * Σ_i (signed Δsize_i / |price_i − mid|) over the levels touched between
   * this emit and the previous one. Bid Δqty contributes natural sign,
   * ask Δqty negated, so positive = buy pressure, negative = sell pressure.
   * Always 0 on keyframes (no prior window to diff against). Levels
   * exactly at mid are skipped (1/0 undefined).
   */
  volumeWeightedChange?: string | undefined
  /**
   * Gross visible volume (sum across all bid / ask levels respectively)
   * and signed difference. Honours imbalance_depth_limit.
   */
  totalBidVolume?: string | undefined
  totalAskVolume?: string | undefined
  totalDelta?: string | undefined
  /**
   * Near-the-money volume — bids with price >= mid * (1 - near_money_pct)
   * and asks with price <= mid * (1 + near_money_pct). Default pct = 1%.
   */
  nearMoneyBidVolume?: string | undefined
  nearMoneyAskVolume?: string | undefined
  nearMoneyDelta?: string | undefined
  /** (best_bid + best_ask) / 2. Unset when either side is empty. */
  midPrice?: string | undefined
  /**
   * Liquidity flow time-series, oldest → newest. Each bucket spans
   * flow_resolution_ms; up to flow_history_length buckets retained.
   * net_delta is the signed sum of Δqty across both sides during the
   * bucket window (positive = book grew, negative = book shrunk).
   */
  volumeDeltaHistory: VolumeBucket[]
}

export interface VolumeBucket {
  /** Bucket start, unix ms. */
  timestamp: string
  /** Σ Δqty (signed) across both sides; decimal string. */
  netDelta: string
}

/** Instrument information */
export interface Instrument {
  /** Internal unique ID for fast lookups */
  internalId: string
  /** Human readable (BTC-PERP) */
  symbol: string
  /** Native exchange string (BTC-24APR26) */
  exchangeSymbol: string
  /** Native exchange numeric ID (if available) */
  exchangeId: string
  exchange: Exchange
  /** SPOT, FUTURE, PERP, OPTION */
  kind: InstrumentKind
  /** Currencies */
  baseCurrency: string
  quoteCurrency: string
  /** Crucial for Inverse and multi-collateral */
  settlementCurrency: string
  /** Precision and Limits (Stored as fixed-point or doubles for config) */
  tickSize: string
  minTradeAmount: string
  contractSize: string
  /**
   * Price step increment (e.g. "0.01"), matching tick_size — NOT a decimal-place
   * count. Every producer sets this equal to tick_size; treat it the same way.
   */
  pricePrecision: string
  /**
   * Quantity step increment (e.g. "0.001"), matching min_trade_amount — NOT a
   * decimal-place count. Every producer sets this equal to min_trade_amount;
   * treat it the same way.
   */
  qtyPrecision: string
  /** Derivatives Specific */
  type?: InstrumentType | undefined
  /** CALL, PUT */
  optionType?: OptionType | undefined
  strikePrice?: string | undefined
  expirationTsMs?: string | undefined
  /** Perpetual Specific */
  fundingInterval?: string | undefined
  /** Trading Status */
  isActive: boolean
  /**
   * Variable tick-size schedule (Deribit-style). Empty when the instrument has
   * a single fixed tick. When present, the applicable tick is the largest step
   * whose `above_price` is <= the current price; below the smallest threshold
   * the base `tick_size` (field 10) applies.
   */
  tickSizeSteps: TickSizeStep[]
  /**
   * Venue base (standard, no-discount) commission rates as decimal strings.
   * Deribit `get_instruments` maker/taker_commission; absent when the venue
   * does not report a per-instrument base. Internal cache plumbing for the
   * effective-fee merge — not a frontend field.
   */
  makerCommission?: string | undefined
  takerCommission?: string | undefined
  /**
   * Deribit price index this instrument keys into (e.g. `btc_usd`, `btc_usdc`) —
   * the exact key for the per-account fee overlay, carried structurally rather
   * than reconstructed from the symbol prefix. Absent for venues that don't
   * report one. Internal cache plumbing, not a frontend field.
   */
  priceIndex?: string | undefined
  /**
   * Venue's per-instrument max leverage ceiling, decimal as string. Absent for
   * spot/options and for venues that don't expose one. Internal cache
   * plumbing (order-preview margin engine), not a frontend field.
   */
  maxLeverage?: string | undefined
  /**
   * Cross-exchange enrichment layer (canonical grouping + taxonomy + human-readable
   * metadata), produced by the instrument_enrichment lambda. Absent until enriched.
   */
  enrichment?: InstrumentEnrichment | undefined
  /**
   * Venue floor on a single order's *notional*, denominated in `quote_currency`,
   * as a decimal string. Absent when the venue reports no notional floor.
   *
   * Distinct from `min_trade_amount` (field 11), which is a *quantity* floor
   * whose own currency follows the contract: base units on a linear contract,
   * quote units on an inverse one (Deribit BTC-PERPETUAL's `10` is $10, not
   * 10 BTC). Several venues enforce the two independently, so clearing one
   * does not imply clearing the other — Lighter ETH-PERP requires both
   * 0.0050 ETH and $10, and 0.0050 ETH is only about $9.60.
   *
   * Consumers sizing an order must satisfy both fields. Sizing against
   * `min_trade_amount` alone is the failure this field exists to close.
   */
  minNotional?: string | undefined
  /**
   * The venue's OWN classification token for this instrument, verbatim and
   * un-normalised: Bybit `symbolType` ("stock" / "ETF" / "commodity" /
   * "innovation"), or the Hyperliquid HIP-3 deployer a perp is listed under
   * ("vntl", "xyz"). Venues share no vocabulary here, so this is deliberately
   * a free string and NOT an enum — consumers must treat an unrecognised
   * value as "unknown", never as a default.
   *
   * Producers MUST omit rather than send "": Bybit reports an empty
   * `symbolType` for plain crypto, which carries no information.
   *
   * Input to instrument enrichment — it is the equity-vs-crypto signal the AI
   * classifier otherwise has to guess from the ticker alone. It rides the same
   * instrument list the frontend reads, but nothing should render it.
   *
   * Venue-authored, and permissionless on some venues, so consumers MUST treat
   * it as untrusted text: sanitize before it reaches a prompt, a shell, or a
   * file a human is told to paste from.
   */
  venueInstrumentType?: string | undefined
  /**
   * The venue's own human-readable name for the base asset, verbatim: Upbit
   * `english_name` ("The Interfold"), Hyperliquid `spotMeta.tokens[].fullName`
   * ("Space Exploration Technologies Corp."). Decodes opaque tickers that no
   * amount of prior knowledge resolves.
   *
   * Distinct from `display_name` inside `enrichment` (field 26), which is OUR
   * curated or AI-drafted name — this one is raw venue input to that process,
   * and the two must not be conflated. It rides the same instrument list the
   * frontend reads, but nothing should render it.
   *
   * On a permissionless venue this string is written by whoever listed the
   * token, so it is untrusted: sanitize before it reaches a prompt, a shell, or
   * a file a human is told to paste from.
   */
  venueReportedName?: string | undefined
  /**
   * True when the venue does not match this instrument on its own engine but
   * routes it to an external one, leaving its market-data and order surface a
   * strict subset of the venue's normal one.
   *
   * Deribit sets `is_csr` (and, on `get_instrument`/`get_instruments` only, the
   * companion key `is_cbe_routed`) on the spot instruments it routes to
   * Coinbase Exchange, from release 18.08.2026. For those:
   *   - no trades are served: `trades.*` and `chart.trades.*` are silently
   *     dropped from the channel list `public/subscribe` accepts, and the
   *     `get_last_trades_by_*` REST calls answer 11060. Order books are
   *     unaffected and `ticker.*` still flows, minus `volume_notional` /
   *     `volume_usd`.
   *   - only limit / market / stop_limit orders are accepted, a stop-limit's
   *     trigger must be `last_price`, and iceberg `display_amount` (11059) and
   *     linked OTO/OCO/OTOCO orders (13922) are rejected.
   *   - post-only IS accepted, but only together with `reject_post_only: true`
   *     (11055 otherwise): Coinbase can cancel a crossing quote, not reprice it
   *     the way Deribit's own engine does. So a maker-only order still works —
   *     it just cancels instead of repricing when it would cross.
   *
   * Not routing-specific, but easy to conflate with it: `reduce_only` and
   * `good_til_day` are unavailable on ALL Deribit spot, routed or not, and come
   * back as `-32602 Invalid params` rather than a routed-spot code.
   *
   * Producers MUST omit rather than send `false`: absent means "this venue
   * reports no external routing", which is not the same claim as "the venue
   * told us this one is matched in house".
   */
  isExternallyRouted?: boolean | undefined
  /**
   * The instrument's underlying, when it is listed on a DIFFERENT exchange than
   * this instrument. Absent means the underlying is on this instrument's own
   * exchange, or that this instrument has none — which is what every consumer
   * assumed before this field existed, so absence is the compatible default.
   *
   * Two sources, and both stamp it on derivatives only:
   * - the venue's own definition record: OPRA IBIT/ETHA options deliver ETFs
   *   listed on XNAS. Present in REF_DATA_INSTRUMENTS and the enriched copy.
   * - curation: a Hyperliquid/Lighter perp on a US stock or ETF points at its
   *   XNAS listing (`XYZ-AAPL-PERP` -> {EXCHANGE_XNAS, AAPL}). A reviewed
   *   identity stamped by instrument-enrichment only where the venue left the
   *   field empty, so it exists in REF_DATA_MASTER_INSTRUMENTS only.
   *
   * Neither is checked for liveness: the named symbol may be absent from that
   * exchange's current instrument list. Consumers must tolerate a dangling
   * reference.
   */
  underlying?: UnderlyingRef | undefined
  /**
   * Options only. Databento reads CFI position 3 (A/E/B); Deribit, Bybit and
   * Derive options are European.
   */
  exerciseStyle?: ExerciseStyle | undefined
}

export interface InstrumentEnrichment {
  /**
   * Stable grouping key unifying mismatched tickers for one underlying.
   * e.g. "BTC" for BTC/IBTC/WBTC/BTC-PERP/BTC options; "OIL" for BRENTOIL/WTI.
   */
  canonicalGroup: string
  assetClass: AssetClass
  /** ["Energy"], ["L1","Store-of-Value"] */
  sectorTags: string[]
  /** "Brent Crude Oil", "Bitcoin Perpetual" */
  displayName: string
  /** short free text; the "what is XYZ100" answer */
  description: string
  status: EnrichmentStatus
  source: EnrichmentSource
  /** AI drafts only */
  confidence?: number | undefined
  enrichedAtMs?: string | undefined
  /**
   * Venue-reported 24h volume, raw basis (mixed base/quote units across
   * venues — a same-exchange relative ranking signal for UI sort, never a
   * normalized figure). Refreshed on its own ~24h cadence, independent of the
   * enrichment waterfall above. Absent until the first volume refresh
   * observes this instrument's (exchange, symbol) in the live ticker stream.
   */
  volume24h?: string | undefined
  volumeUpdatedAtMs?: string | undefined
  /**
   * Key into the self-hosted instrument-icon CDN library (bare filename minus
   * extension). Absent means no curated icon exists yet — the frontend shows
   * a generic letter avatar, nothing else (there is no other icon fallback).
   */
  iconTag?: string | undefined
  /**
   * ISO 3166-1 alpha-2 country codes the underlying is tied to (e.g. ["KR"]
   * for a Korean equity, ["DE"] for a German stock). Repeated: cross-listed
   * or ambiguous instruments may carry several. Empty = global/crypto-native
   * (BTC carries no region). Filled by the same waterfall as sector_tags;
   * the AI watchlist generator filters on this.
   */
  regionTags: string[]
}

/**
 * Names an instrument on another exchange. Used by Instrument.underlying, where
 * the (exchange, symbol) pair is what makes the reference resolvable — a bare
 * symbol is ambiguous across venues.
 */
export interface UnderlyingRef {
  exchange: Exchange
  symbol: string
}

/**
 * One step in a variable tick-size schedule. Both fields are decimal strings
 * to match the rest of the price/qty fields on Instrument.
 */
export interface TickSizeStep {
  abovePrice: string
  tickSize: string
}

/** Ticker information */
export interface Ticker {
  symbol: string
  exchange: Exchange
  bidPrice?: string | undefined
  askPrice?: string | undefined
  bestBidQuantity?: string | undefined
  bestAskQuantity?: string | undefined
  lastPrice?: string | undefined
  volume24h?: string | undefined
  priceChange24h?: string | undefined
  priceChangePercent24h?: string | undefined
  high24h?: string | undefined
  low24h?: string | undefined
  minPrice?: string | undefined
  maxPrice?: string | undefined
  /** Implied volatility for options */
  iv?: string | undefined
  openInterest?: string | undefined
  indexPrice?: string | undefined
  markPrice?: string | undefined
  strikePrice?: string | undefined
  /** Unix timestamp in nanoseconds */
  expiry?: string | undefined
  fundingRate?: string | undefined
  /** pre-calculated: ln(price / prev_price) */
  logReturn?: string | undefined
  underlyingPrice?: string | undefined
  /** ENG-613: option underlying ("BTC", "BTC_USDC"); option rows only */
  underlying?: string | undefined
  /** ENG-613: call/put for option rows; absent for perps/futures/spot */
  optionType?: OptionType | undefined
  /**
   * Next funding settlement, Unix timestamp in nanoseconds (same unit as
   * expiry; `timestamp` below is ms). Perpetuals only; absent for spot,
   * futures, options.
   */
  nextFundingTime?: string | undefined
  /** Unix timestamp in milliseconds */
  timestamp: string
}

/** Generic Option Greeks */
export interface Greeks {
  delta?: string | undefined
  gamma?: string | undefined
  theta?: string | undefined
  vega?: string | undefined
  rho?: string | undefined
}

/** Generic 24h Statistics */
export interface TickerStats {
  /** Decimal as string */
  high?: string | undefined
  /** Decimal as string */
  low?: string | undefined
  /** 24h change % */
  priceChangePercent?: string | undefined
  /** "volume" in Deribit */
  volumeBase?: string | undefined
  /** "volume_usd" in Deribit */
  volumeQuote?: string | undefined
}

/** Exchange-Agnostic Ticker */
export interface IncrementalTicker {
  /** Identity */
  symbol: string
  /** Unix ms */
  timestamp: string
  /** "snapshot" or "update" */
  type: UpdateType
  /** "open", "closed", "halted" */
  state?: string | undefined
  exchange: Exchange
  /** Core Pricing (Strings for precision) */
  lastPrice?: string | undefined
  bestBidPrice?: string | undefined
  bestAskPrice?: string | undefined
  markPrice?: string | undefined
  indexPrice?: string | undefined
  settlementPrice?: string | undefined
  /** Quantities */
  bestBidQuantity?: string | undefined
  /** "amount" in Deribit */
  bestAskQuantity?: string | undefined
  openInterest?: string | undefined
  /** Volatility & Options Data (Specific to Deribit/Options) */
  markIv?: string | undefined
  bidIv?: string | undefined
  askIv?: string | undefined
  underlyingPrice?: string | undefined
  /** e.g. "SYN.BTC-20DEC25" */
  underlyingIndex?: string | undefined
  interestRate?: string | undefined
  /** Nested Data */
  greeks?: Greeks | undefined
  stats?: TickerStats | undefined
  /** Limits */
  minPrice?: string | undefined
  maxPrice?: string | undefined
  estimatedDeliveryPrice?: string | undefined
  /** per-interval perp funding rate (Deribit funding_8h / Bybit fundingRate); absent on non-perp frames */
  fundingRate?: string | undefined
  /**
   * Next funding settlement, Unix timestamp in NANOSECONDS (same unit as
   * Ticker.next_funding_time, not this message's ms `timestamp`). Perps only.
   */
  nextFundingTime?: string | undefined
}

export interface InstrumentState {
  /** Normalized (e.g., BTC-PERP or BTC-20DEC25-C) */
  symbol: string
  /** Unix ms */
  timestamp: string
  state: InstrumentStateType
  exchange: Exchange
}

export interface InstrumentStateList {
  instrumentStates: InstrumentState[]
}

export interface IncrementalTickerList {
  incrementalTickers: IncrementalTicker[]
}

/** List wrappers for market data */
export interface InstrumentList {
  instruments: Instrument[]
}

export interface TickerList {
  tickers: Ticker[]
}

export interface OrderBookList {
  orderBooks: OrderBook[]
}

function createBaseBookEntry(): BookEntry {
  return { action: undefined, price: '', quantity: '' }
}

export const BookEntry: MessageFns<BookEntry> = {
  encode(message: BookEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.action !== undefined) {
      writer.uint32(8).int32(message.action)
    }
    if (message.price !== '') {
      writer.uint32(18).string(message.price)
    }
    if (message.quantity !== '') {
      writer.uint32(26).string(message.quantity)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BookEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBookEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.action = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.price = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.quantity = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): BookEntry {
    return {
      action: isSet(object.action) ? bookActionFromJSON(object.action) : undefined,
      price: isSet(object.price) ? globalThis.String(object.price) : '',
      quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
    }
  },

  toJSON(message: BookEntry): unknown {
    const obj: any = {}
    if (message.action !== undefined) {
      obj.action = bookActionToJSON(message.action)
    }
    if (message.price !== '') {
      obj.price = message.price
    }
    if (message.quantity !== '') {
      obj.quantity = message.quantity
    }
    return obj
  },

  create<I extends Exact<DeepPartial<BookEntry>, I>>(base?: I): BookEntry {
    return BookEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<BookEntry>, I>>(object: I): BookEntry {
    const message = createBaseBookEntry()
    message.action = object.action ?? undefined
    message.price = object.price ?? ''
    message.quantity = object.quantity ?? ''
    return message
  },
}

function createBaseOrderBook(): OrderBook {
  return {
    symbol: '',
    exchange: 0,
    bids: [],
    asks: [],
    timestamp: '0',
    type: 0,
    changeId: '0',
    prevChangeId: undefined,
    imbalanceRatio: undefined,
    updateRateHz: undefined,
    volumeWeightedChange: undefined,
    totalBidVolume: undefined,
    totalAskVolume: undefined,
    totalDelta: undefined,
    nearMoneyBidVolume: undefined,
    nearMoneyAskVolume: undefined,
    nearMoneyDelta: undefined,
    midPrice: undefined,
    volumeDeltaHistory: [],
  }
}

export const OrderBook: MessageFns<OrderBook> = {
  encode(message: OrderBook, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    for (const v of message.bids) {
      BookEntry.encode(v!, writer.uint32(26).fork()).join()
    }
    for (const v of message.asks) {
      BookEntry.encode(v!, writer.uint32(34).fork()).join()
    }
    if (message.timestamp !== '0') {
      writer.uint32(40).int64(message.timestamp)
    }
    if (message.type !== 0) {
      writer.uint32(48).int32(message.type)
    }
    if (message.changeId !== '0') {
      writer.uint32(56).int64(message.changeId)
    }
    if (message.prevChangeId !== undefined) {
      writer.uint32(64).int64(message.prevChangeId)
    }
    if (message.imbalanceRatio !== undefined) {
      writer.uint32(74).string(message.imbalanceRatio)
    }
    if (message.updateRateHz !== undefined) {
      writer.uint32(80).int32(message.updateRateHz)
    }
    if (message.volumeWeightedChange !== undefined) {
      writer.uint32(90).string(message.volumeWeightedChange)
    }
    if (message.totalBidVolume !== undefined) {
      writer.uint32(98).string(message.totalBidVolume)
    }
    if (message.totalAskVolume !== undefined) {
      writer.uint32(106).string(message.totalAskVolume)
    }
    if (message.totalDelta !== undefined) {
      writer.uint32(114).string(message.totalDelta)
    }
    if (message.nearMoneyBidVolume !== undefined) {
      writer.uint32(122).string(message.nearMoneyBidVolume)
    }
    if (message.nearMoneyAskVolume !== undefined) {
      writer.uint32(130).string(message.nearMoneyAskVolume)
    }
    if (message.nearMoneyDelta !== undefined) {
      writer.uint32(138).string(message.nearMoneyDelta)
    }
    if (message.midPrice !== undefined) {
      writer.uint32(146).string(message.midPrice)
    }
    for (const v of message.volumeDeltaHistory) {
      VolumeBucket.encode(v!, writer.uint32(154).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderBook {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderBook()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.bids.push(BookEntry.decode(reader, reader.uint32()))
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.asks.push(BookEntry.decode(reader, reader.uint32()))
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.type = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.changeId = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.prevChangeId = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.imbalanceRatio = reader.string()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.updateRateHz = reader.int32()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.volumeWeightedChange = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.totalBidVolume = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.totalAskVolume = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.totalDelta = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.nearMoneyBidVolume = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.nearMoneyAskVolume = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.nearMoneyDelta = reader.string()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.midPrice = reader.string()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.volumeDeltaHistory.push(VolumeBucket.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderBook {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      bids: globalThis.Array.isArray(object?.bids)
        ? object.bids.map((e: any) => BookEntry.fromJSON(e))
        : [],
      asks: globalThis.Array.isArray(object?.asks)
        ? object.asks.map((e: any) => BookEntry.fromJSON(e))
        : [],
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      changeId: isSet(object.changeId)
        ? globalThis.String(object.changeId)
        : isSet(object.change_id)
          ? globalThis.String(object.change_id)
          : '0',
      prevChangeId: isSet(object.prevChangeId)
        ? globalThis.String(object.prevChangeId)
        : isSet(object.prev_change_id)
          ? globalThis.String(object.prev_change_id)
          : undefined,
      imbalanceRatio: isSet(object.imbalanceRatio)
        ? globalThis.String(object.imbalanceRatio)
        : isSet(object.imbalance_ratio)
          ? globalThis.String(object.imbalance_ratio)
          : undefined,
      updateRateHz: isSet(object.updateRateHz)
        ? globalThis.Number(object.updateRateHz)
        : isSet(object.update_rate_hz)
          ? globalThis.Number(object.update_rate_hz)
          : undefined,
      volumeWeightedChange: isSet(object.volumeWeightedChange)
        ? globalThis.String(object.volumeWeightedChange)
        : isSet(object.volume_weighted_change)
          ? globalThis.String(object.volume_weighted_change)
          : undefined,
      totalBidVolume: isSet(object.totalBidVolume)
        ? globalThis.String(object.totalBidVolume)
        : isSet(object.total_bid_volume)
          ? globalThis.String(object.total_bid_volume)
          : undefined,
      totalAskVolume: isSet(object.totalAskVolume)
        ? globalThis.String(object.totalAskVolume)
        : isSet(object.total_ask_volume)
          ? globalThis.String(object.total_ask_volume)
          : undefined,
      totalDelta: isSet(object.totalDelta)
        ? globalThis.String(object.totalDelta)
        : isSet(object.total_delta)
          ? globalThis.String(object.total_delta)
          : undefined,
      nearMoneyBidVolume: isSet(object.nearMoneyBidVolume)
        ? globalThis.String(object.nearMoneyBidVolume)
        : isSet(object.near_money_bid_volume)
          ? globalThis.String(object.near_money_bid_volume)
          : undefined,
      nearMoneyAskVolume: isSet(object.nearMoneyAskVolume)
        ? globalThis.String(object.nearMoneyAskVolume)
        : isSet(object.near_money_ask_volume)
          ? globalThis.String(object.near_money_ask_volume)
          : undefined,
      nearMoneyDelta: isSet(object.nearMoneyDelta)
        ? globalThis.String(object.nearMoneyDelta)
        : isSet(object.near_money_delta)
          ? globalThis.String(object.near_money_delta)
          : undefined,
      midPrice: isSet(object.midPrice)
        ? globalThis.String(object.midPrice)
        : isSet(object.mid_price)
          ? globalThis.String(object.mid_price)
          : undefined,
      volumeDeltaHistory: globalThis.Array.isArray(object?.volumeDeltaHistory)
        ? object.volumeDeltaHistory.map((e: any) => VolumeBucket.fromJSON(e))
        : globalThis.Array.isArray(object?.volume_delta_history)
          ? object.volume_delta_history.map((e: any) => VolumeBucket.fromJSON(e))
          : [],
    }
  },

  toJSON(message: OrderBook): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.bids?.length) {
      obj.bids = message.bids.map((e) => BookEntry.toJSON(e))
    }
    if (message.asks?.length) {
      obj.asks = message.asks.map((e) => BookEntry.toJSON(e))
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type)
    }
    if (message.changeId !== '0') {
      obj.changeId = message.changeId
    }
    if (message.prevChangeId !== undefined) {
      obj.prevChangeId = message.prevChangeId
    }
    if (message.imbalanceRatio !== undefined) {
      obj.imbalanceRatio = message.imbalanceRatio
    }
    if (message.updateRateHz !== undefined) {
      obj.updateRateHz = Math.round(message.updateRateHz)
    }
    if (message.volumeWeightedChange !== undefined) {
      obj.volumeWeightedChange = message.volumeWeightedChange
    }
    if (message.totalBidVolume !== undefined) {
      obj.totalBidVolume = message.totalBidVolume
    }
    if (message.totalAskVolume !== undefined) {
      obj.totalAskVolume = message.totalAskVolume
    }
    if (message.totalDelta !== undefined) {
      obj.totalDelta = message.totalDelta
    }
    if (message.nearMoneyBidVolume !== undefined) {
      obj.nearMoneyBidVolume = message.nearMoneyBidVolume
    }
    if (message.nearMoneyAskVolume !== undefined) {
      obj.nearMoneyAskVolume = message.nearMoneyAskVolume
    }
    if (message.nearMoneyDelta !== undefined) {
      obj.nearMoneyDelta = message.nearMoneyDelta
    }
    if (message.midPrice !== undefined) {
      obj.midPrice = message.midPrice
    }
    if (message.volumeDeltaHistory?.length) {
      obj.volumeDeltaHistory = message.volumeDeltaHistory.map((e) => VolumeBucket.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderBook>, I>>(base?: I): OrderBook {
    return OrderBook.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderBook>, I>>(object: I): OrderBook {
    const message = createBaseOrderBook()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.bids = object.bids?.map((e) => BookEntry.fromPartial(e)) || []
    message.asks = object.asks?.map((e) => BookEntry.fromPartial(e)) || []
    message.timestamp = object.timestamp ?? '0'
    message.type = object.type ?? 0
    message.changeId = object.changeId ?? '0'
    message.prevChangeId = object.prevChangeId ?? undefined
    message.imbalanceRatio = object.imbalanceRatio ?? undefined
    message.updateRateHz = object.updateRateHz ?? undefined
    message.volumeWeightedChange = object.volumeWeightedChange ?? undefined
    message.totalBidVolume = object.totalBidVolume ?? undefined
    message.totalAskVolume = object.totalAskVolume ?? undefined
    message.totalDelta = object.totalDelta ?? undefined
    message.nearMoneyBidVolume = object.nearMoneyBidVolume ?? undefined
    message.nearMoneyAskVolume = object.nearMoneyAskVolume ?? undefined
    message.nearMoneyDelta = object.nearMoneyDelta ?? undefined
    message.midPrice = object.midPrice ?? undefined
    message.volumeDeltaHistory =
      object.volumeDeltaHistory?.map((e) => VolumeBucket.fromPartial(e)) || []
    return message
  },
}

function createBaseVolumeBucket(): VolumeBucket {
  return { timestamp: '0', netDelta: '' }
}

export const VolumeBucket: MessageFns<VolumeBucket> = {
  encode(message: VolumeBucket, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== '0') {
      writer.uint32(8).int64(message.timestamp)
    }
    if (message.netDelta !== '') {
      writer.uint32(18).string(message.netDelta)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VolumeBucket {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVolumeBucket()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.netDelta = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): VolumeBucket {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      netDelta: isSet(object.netDelta)
        ? globalThis.String(object.netDelta)
        : isSet(object.net_delta)
          ? globalThis.String(object.net_delta)
          : '',
    }
  },

  toJSON(message: VolumeBucket): unknown {
    const obj: any = {}
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.netDelta !== '') {
      obj.netDelta = message.netDelta
    }
    return obj
  },

  create<I extends Exact<DeepPartial<VolumeBucket>, I>>(base?: I): VolumeBucket {
    return VolumeBucket.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<VolumeBucket>, I>>(object: I): VolumeBucket {
    const message = createBaseVolumeBucket()
    message.timestamp = object.timestamp ?? '0'
    message.netDelta = object.netDelta ?? ''
    return message
  },
}

function createBaseInstrument(): Instrument {
  return {
    internalId: '0',
    symbol: '',
    exchangeSymbol: '',
    exchangeId: '0',
    exchange: 0,
    kind: 0,
    baseCurrency: '',
    quoteCurrency: '',
    settlementCurrency: '',
    tickSize: '',
    minTradeAmount: '',
    contractSize: '',
    pricePrecision: '',
    qtyPrecision: '',
    type: undefined,
    optionType: undefined,
    strikePrice: undefined,
    expirationTsMs: undefined,
    fundingInterval: undefined,
    isActive: false,
    tickSizeSteps: [],
    makerCommission: undefined,
    takerCommission: undefined,
    priceIndex: undefined,
    maxLeverage: undefined,
    enrichment: undefined,
    minNotional: undefined,
    venueInstrumentType: undefined,
    venueReportedName: undefined,
    isExternallyRouted: undefined,
    underlying: undefined,
    exerciseStyle: undefined,
  }
}

export const Instrument: MessageFns<Instrument> = {
  encode(message: Instrument, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.internalId !== '0') {
      writer.uint32(8).uint64(message.internalId)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    if (message.exchangeSymbol !== '') {
      writer.uint32(26).string(message.exchangeSymbol)
    }
    if (message.exchangeId !== '0') {
      writer.uint32(32).uint64(message.exchangeId)
    }
    if (message.exchange !== 0) {
      writer.uint32(40).int32(message.exchange)
    }
    if (message.kind !== 0) {
      writer.uint32(48).int32(message.kind)
    }
    if (message.baseCurrency !== '') {
      writer.uint32(58).string(message.baseCurrency)
    }
    if (message.quoteCurrency !== '') {
      writer.uint32(66).string(message.quoteCurrency)
    }
    if (message.settlementCurrency !== '') {
      writer.uint32(74).string(message.settlementCurrency)
    }
    if (message.tickSize !== '') {
      writer.uint32(82).string(message.tickSize)
    }
    if (message.minTradeAmount !== '') {
      writer.uint32(90).string(message.minTradeAmount)
    }
    if (message.contractSize !== '') {
      writer.uint32(98).string(message.contractSize)
    }
    if (message.pricePrecision !== '') {
      writer.uint32(106).string(message.pricePrecision)
    }
    if (message.qtyPrecision !== '') {
      writer.uint32(114).string(message.qtyPrecision)
    }
    if (message.type !== undefined) {
      writer.uint32(120).int32(message.type)
    }
    if (message.optionType !== undefined) {
      writer.uint32(128).int32(message.optionType)
    }
    if (message.strikePrice !== undefined) {
      writer.uint32(138).string(message.strikePrice)
    }
    if (message.expirationTsMs !== undefined) {
      writer.uint32(144).int64(message.expirationTsMs)
    }
    if (message.fundingInterval !== undefined) {
      writer.uint32(154).string(message.fundingInterval)
    }
    if (message.isActive !== false) {
      writer.uint32(160).bool(message.isActive)
    }
    for (const v of message.tickSizeSteps) {
      TickSizeStep.encode(v!, writer.uint32(170).fork()).join()
    }
    if (message.makerCommission !== undefined) {
      writer.uint32(178).string(message.makerCommission)
    }
    if (message.takerCommission !== undefined) {
      writer.uint32(186).string(message.takerCommission)
    }
    if (message.priceIndex !== undefined) {
      writer.uint32(194).string(message.priceIndex)
    }
    if (message.maxLeverage !== undefined) {
      writer.uint32(202).string(message.maxLeverage)
    }
    if (message.enrichment !== undefined) {
      InstrumentEnrichment.encode(message.enrichment, writer.uint32(210).fork()).join()
    }
    if (message.minNotional !== undefined) {
      writer.uint32(218).string(message.minNotional)
    }
    if (message.venueInstrumentType !== undefined) {
      writer.uint32(226).string(message.venueInstrumentType)
    }
    if (message.venueReportedName !== undefined) {
      writer.uint32(234).string(message.venueReportedName)
    }
    if (message.isExternallyRouted !== undefined) {
      writer.uint32(240).bool(message.isExternallyRouted)
    }
    if (message.underlying !== undefined) {
      UnderlyingRef.encode(message.underlying, writer.uint32(250).fork()).join()
    }
    if (message.exerciseStyle !== undefined) {
      writer.uint32(256).int32(message.exerciseStyle)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Instrument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrument()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.internalId = reader.uint64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.exchangeSymbol = reader.string()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.exchangeId = reader.uint64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.baseCurrency = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.quoteCurrency = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.settlementCurrency = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.tickSize = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.minTradeAmount = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.contractSize = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.pricePrecision = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.qtyPrecision = reader.string()
          continue
        }
        case 15: {
          if (tag !== 120) {
            break
          }

          message.type = reader.int32() as any
          continue
        }
        case 16: {
          if (tag !== 128) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.strikePrice = reader.string()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.expirationTsMs = reader.int64().toString()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.fundingInterval = reader.string()
          continue
        }
        case 20: {
          if (tag !== 160) {
            break
          }

          message.isActive = reader.bool()
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.tickSizeSteps.push(TickSizeStep.decode(reader, reader.uint32()))
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.makerCommission = reader.string()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.takerCommission = reader.string()
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.priceIndex = reader.string()
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.maxLeverage = reader.string()
          continue
        }
        case 26: {
          if (tag !== 210) {
            break
          }

          message.enrichment = InstrumentEnrichment.decode(reader, reader.uint32())
          continue
        }
        case 27: {
          if (tag !== 218) {
            break
          }

          message.minNotional = reader.string()
          continue
        }
        case 28: {
          if (tag !== 226) {
            break
          }

          message.venueInstrumentType = reader.string()
          continue
        }
        case 29: {
          if (tag !== 234) {
            break
          }

          message.venueReportedName = reader.string()
          continue
        }
        case 30: {
          if (tag !== 240) {
            break
          }

          message.isExternallyRouted = reader.bool()
          continue
        }
        case 31: {
          if (tag !== 250) {
            break
          }

          message.underlying = UnderlyingRef.decode(reader, reader.uint32())
          continue
        }
        case 32: {
          if (tag !== 256) {
            break
          }

          message.exerciseStyle = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Instrument {
    return {
      internalId: isSet(object.internalId)
        ? globalThis.String(object.internalId)
        : isSet(object.internal_id)
          ? globalThis.String(object.internal_id)
          : '0',
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchangeSymbol: isSet(object.exchangeSymbol)
        ? globalThis.String(object.exchangeSymbol)
        : isSet(object.exchange_symbol)
          ? globalThis.String(object.exchange_symbol)
          : '',
      exchangeId: isSet(object.exchangeId)
        ? globalThis.String(object.exchangeId)
        : isSet(object.exchange_id)
          ? globalThis.String(object.exchange_id)
          : '0',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      kind: isSet(object.kind) ? instrumentKindFromJSON(object.kind) : 0,
      baseCurrency: isSet(object.baseCurrency)
        ? globalThis.String(object.baseCurrency)
        : isSet(object.base_currency)
          ? globalThis.String(object.base_currency)
          : '',
      quoteCurrency: isSet(object.quoteCurrency)
        ? globalThis.String(object.quoteCurrency)
        : isSet(object.quote_currency)
          ? globalThis.String(object.quote_currency)
          : '',
      settlementCurrency: isSet(object.settlementCurrency)
        ? globalThis.String(object.settlementCurrency)
        : isSet(object.settlement_currency)
          ? globalThis.String(object.settlement_currency)
          : '',
      tickSize: isSet(object.tickSize)
        ? globalThis.String(object.tickSize)
        : isSet(object.tick_size)
          ? globalThis.String(object.tick_size)
          : '',
      minTradeAmount: isSet(object.minTradeAmount)
        ? globalThis.String(object.minTradeAmount)
        : isSet(object.min_trade_amount)
          ? globalThis.String(object.min_trade_amount)
          : '',
      contractSize: isSet(object.contractSize)
        ? globalThis.String(object.contractSize)
        : isSet(object.contract_size)
          ? globalThis.String(object.contract_size)
          : '',
      pricePrecision: isSet(object.pricePrecision)
        ? globalThis.String(object.pricePrecision)
        : isSet(object.price_precision)
          ? globalThis.String(object.price_precision)
          : '',
      qtyPrecision: isSet(object.qtyPrecision)
        ? globalThis.String(object.qtyPrecision)
        : isSet(object.qty_precision)
          ? globalThis.String(object.qty_precision)
          : '',
      type: isSet(object.type) ? instrumentTypeFromJSON(object.type) : undefined,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
      strikePrice: isSet(object.strikePrice)
        ? globalThis.String(object.strikePrice)
        : isSet(object.strike_price)
          ? globalThis.String(object.strike_price)
          : undefined,
      expirationTsMs: isSet(object.expirationTsMs)
        ? globalThis.String(object.expirationTsMs)
        : isSet(object.expiration_ts_ms)
          ? globalThis.String(object.expiration_ts_ms)
          : undefined,
      fundingInterval: isSet(object.fundingInterval)
        ? globalThis.String(object.fundingInterval)
        : isSet(object.funding_interval)
          ? globalThis.String(object.funding_interval)
          : undefined,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
          ? globalThis.Boolean(object.is_active)
          : false,
      tickSizeSteps: globalThis.Array.isArray(object?.tickSizeSteps)
        ? object.tickSizeSteps.map((e: any) => TickSizeStep.fromJSON(e))
        : globalThis.Array.isArray(object?.tick_size_steps)
          ? object.tick_size_steps.map((e: any) => TickSizeStep.fromJSON(e))
          : [],
      makerCommission: isSet(object.makerCommission)
        ? globalThis.String(object.makerCommission)
        : isSet(object.maker_commission)
          ? globalThis.String(object.maker_commission)
          : undefined,
      takerCommission: isSet(object.takerCommission)
        ? globalThis.String(object.takerCommission)
        : isSet(object.taker_commission)
          ? globalThis.String(object.taker_commission)
          : undefined,
      priceIndex: isSet(object.priceIndex)
        ? globalThis.String(object.priceIndex)
        : isSet(object.price_index)
          ? globalThis.String(object.price_index)
          : undefined,
      maxLeverage: isSet(object.maxLeverage)
        ? globalThis.String(object.maxLeverage)
        : isSet(object.max_leverage)
          ? globalThis.String(object.max_leverage)
          : undefined,
      enrichment: isSet(object.enrichment)
        ? InstrumentEnrichment.fromJSON(object.enrichment)
        : undefined,
      minNotional: isSet(object.minNotional)
        ? globalThis.String(object.minNotional)
        : isSet(object.min_notional)
          ? globalThis.String(object.min_notional)
          : undefined,
      venueInstrumentType: isSet(object.venueInstrumentType)
        ? globalThis.String(object.venueInstrumentType)
        : isSet(object.venue_instrument_type)
          ? globalThis.String(object.venue_instrument_type)
          : undefined,
      venueReportedName: isSet(object.venueReportedName)
        ? globalThis.String(object.venueReportedName)
        : isSet(object.venue_reported_name)
          ? globalThis.String(object.venue_reported_name)
          : undefined,
      isExternallyRouted: isSet(object.isExternallyRouted)
        ? globalThis.Boolean(object.isExternallyRouted)
        : isSet(object.is_externally_routed)
          ? globalThis.Boolean(object.is_externally_routed)
          : undefined,
      underlying: isSet(object.underlying) ? UnderlyingRef.fromJSON(object.underlying) : undefined,
      exerciseStyle: isSet(object.exerciseStyle)
        ? exerciseStyleFromJSON(object.exerciseStyle)
        : isSet(object.exercise_style)
          ? exerciseStyleFromJSON(object.exercise_style)
          : undefined,
    }
  },

  toJSON(message: Instrument): unknown {
    const obj: any = {}
    if (message.internalId !== '0') {
      obj.internalId = message.internalId
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchangeSymbol !== '') {
      obj.exchangeSymbol = message.exchangeSymbol
    }
    if (message.exchangeId !== '0') {
      obj.exchangeId = message.exchangeId
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.kind !== 0) {
      obj.kind = instrumentKindToJSON(message.kind)
    }
    if (message.baseCurrency !== '') {
      obj.baseCurrency = message.baseCurrency
    }
    if (message.quoteCurrency !== '') {
      obj.quoteCurrency = message.quoteCurrency
    }
    if (message.settlementCurrency !== '') {
      obj.settlementCurrency = message.settlementCurrency
    }
    if (message.tickSize !== '') {
      obj.tickSize = message.tickSize
    }
    if (message.minTradeAmount !== '') {
      obj.minTradeAmount = message.minTradeAmount
    }
    if (message.contractSize !== '') {
      obj.contractSize = message.contractSize
    }
    if (message.pricePrecision !== '') {
      obj.pricePrecision = message.pricePrecision
    }
    if (message.qtyPrecision !== '') {
      obj.qtyPrecision = message.qtyPrecision
    }
    if (message.type !== undefined) {
      obj.type = instrumentTypeToJSON(message.type)
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.strikePrice !== undefined) {
      obj.strikePrice = message.strikePrice
    }
    if (message.expirationTsMs !== undefined) {
      obj.expirationTsMs = message.expirationTsMs
    }
    if (message.fundingInterval !== undefined) {
      obj.fundingInterval = message.fundingInterval
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive
    }
    if (message.tickSizeSteps?.length) {
      obj.tickSizeSteps = message.tickSizeSteps.map((e) => TickSizeStep.toJSON(e))
    }
    if (message.makerCommission !== undefined) {
      obj.makerCommission = message.makerCommission
    }
    if (message.takerCommission !== undefined) {
      obj.takerCommission = message.takerCommission
    }
    if (message.priceIndex !== undefined) {
      obj.priceIndex = message.priceIndex
    }
    if (message.maxLeverage !== undefined) {
      obj.maxLeverage = message.maxLeverage
    }
    if (message.enrichment !== undefined) {
      obj.enrichment = InstrumentEnrichment.toJSON(message.enrichment)
    }
    if (message.minNotional !== undefined) {
      obj.minNotional = message.minNotional
    }
    if (message.venueInstrumentType !== undefined) {
      obj.venueInstrumentType = message.venueInstrumentType
    }
    if (message.venueReportedName !== undefined) {
      obj.venueReportedName = message.venueReportedName
    }
    if (message.isExternallyRouted !== undefined) {
      obj.isExternallyRouted = message.isExternallyRouted
    }
    if (message.underlying !== undefined) {
      obj.underlying = UnderlyingRef.toJSON(message.underlying)
    }
    if (message.exerciseStyle !== undefined) {
      obj.exerciseStyle = exerciseStyleToJSON(message.exerciseStyle)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Instrument>, I>>(base?: I): Instrument {
    return Instrument.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Instrument>, I>>(object: I): Instrument {
    const message = createBaseInstrument()
    message.internalId = object.internalId ?? '0'
    message.symbol = object.symbol ?? ''
    message.exchangeSymbol = object.exchangeSymbol ?? ''
    message.exchangeId = object.exchangeId ?? '0'
    message.exchange = object.exchange ?? 0
    message.kind = object.kind ?? 0
    message.baseCurrency = object.baseCurrency ?? ''
    message.quoteCurrency = object.quoteCurrency ?? ''
    message.settlementCurrency = object.settlementCurrency ?? ''
    message.tickSize = object.tickSize ?? ''
    message.minTradeAmount = object.minTradeAmount ?? ''
    message.contractSize = object.contractSize ?? ''
    message.pricePrecision = object.pricePrecision ?? ''
    message.qtyPrecision = object.qtyPrecision ?? ''
    message.type = object.type ?? undefined
    message.optionType = object.optionType ?? undefined
    message.strikePrice = object.strikePrice ?? undefined
    message.expirationTsMs = object.expirationTsMs ?? undefined
    message.fundingInterval = object.fundingInterval ?? undefined
    message.isActive = object.isActive ?? false
    message.tickSizeSteps = object.tickSizeSteps?.map((e) => TickSizeStep.fromPartial(e)) || []
    message.makerCommission = object.makerCommission ?? undefined
    message.takerCommission = object.takerCommission ?? undefined
    message.priceIndex = object.priceIndex ?? undefined
    message.maxLeverage = object.maxLeverage ?? undefined
    message.enrichment =
      object.enrichment !== undefined && object.enrichment !== null
        ? InstrumentEnrichment.fromPartial(object.enrichment)
        : undefined
    message.minNotional = object.minNotional ?? undefined
    message.venueInstrumentType = object.venueInstrumentType ?? undefined
    message.venueReportedName = object.venueReportedName ?? undefined
    message.isExternallyRouted = object.isExternallyRouted ?? undefined
    message.underlying =
      object.underlying !== undefined && object.underlying !== null
        ? UnderlyingRef.fromPartial(object.underlying)
        : undefined
    message.exerciseStyle = object.exerciseStyle ?? undefined
    return message
  },
}

function createBaseInstrumentEnrichment(): InstrumentEnrichment {
  return {
    canonicalGroup: '',
    assetClass: 0,
    sectorTags: [],
    displayName: '',
    description: '',
    status: 0,
    source: 0,
    confidence: undefined,
    enrichedAtMs: undefined,
    volume24h: undefined,
    volumeUpdatedAtMs: undefined,
    iconTag: undefined,
    regionTags: [],
  }
}

export const InstrumentEnrichment: MessageFns<InstrumentEnrichment> = {
  encode(message: InstrumentEnrichment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.canonicalGroup !== '') {
      writer.uint32(10).string(message.canonicalGroup)
    }
    if (message.assetClass !== 0) {
      writer.uint32(16).int32(message.assetClass)
    }
    for (const v of message.sectorTags) {
      writer.uint32(26).string(v!)
    }
    if (message.displayName !== '') {
      writer.uint32(34).string(message.displayName)
    }
    if (message.description !== '') {
      writer.uint32(42).string(message.description)
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status)
    }
    if (message.source !== 0) {
      writer.uint32(56).int32(message.source)
    }
    if (message.confidence !== undefined) {
      writer.uint32(69).float(message.confidence)
    }
    if (message.enrichedAtMs !== undefined) {
      writer.uint32(72).int64(message.enrichedAtMs)
    }
    if (message.volume24h !== undefined) {
      writer.uint32(82).string(message.volume24h)
    }
    if (message.volumeUpdatedAtMs !== undefined) {
      writer.uint32(88).int64(message.volumeUpdatedAtMs)
    }
    if (message.iconTag !== undefined) {
      writer.uint32(98).string(message.iconTag)
    }
    for (const v of message.regionTags) {
      writer.uint32(106).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentEnrichment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentEnrichment()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.canonicalGroup = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.assetClass = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sectorTags.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.displayName = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.description = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.status = reader.int32() as any
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.source = reader.int32() as any
          continue
        }
        case 8: {
          if (tag !== 69) {
            break
          }

          message.confidence = reader.float()
          continue
        }
        case 9: {
          if (tag !== 72) {
            break
          }

          message.enrichedAtMs = reader.int64().toString()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.volume24h = reader.string()
          continue
        }
        case 11: {
          if (tag !== 88) {
            break
          }

          message.volumeUpdatedAtMs = reader.int64().toString()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.iconTag = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.regionTags.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentEnrichment {
    return {
      canonicalGroup: isSet(object.canonicalGroup)
        ? globalThis.String(object.canonicalGroup)
        : isSet(object.canonical_group)
          ? globalThis.String(object.canonical_group)
          : '',
      assetClass: isSet(object.assetClass)
        ? assetClassFromJSON(object.assetClass)
        : isSet(object.asset_class)
          ? assetClassFromJSON(object.asset_class)
          : 0,
      sectorTags: globalThis.Array.isArray(object?.sectorTags)
        ? object.sectorTags.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.sector_tags)
          ? object.sector_tags.map((e: any) => globalThis.String(e))
          : [],
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
          ? globalThis.String(object.display_name)
          : '',
      description: isSet(object.description) ? globalThis.String(object.description) : '',
      status: isSet(object.status) ? enrichmentStatusFromJSON(object.status) : 0,
      source: isSet(object.source) ? enrichmentSourceFromJSON(object.source) : 0,
      confidence: isSet(object.confidence) ? globalThis.Number(object.confidence) : undefined,
      enrichedAtMs: isSet(object.enrichedAtMs)
        ? globalThis.String(object.enrichedAtMs)
        : isSet(object.enriched_at_ms)
          ? globalThis.String(object.enriched_at_ms)
          : undefined,
      volume24h: isSet(object.volume24h)
        ? globalThis.String(object.volume24h)
        : isSet(object.volume_24h)
          ? globalThis.String(object.volume_24h)
          : undefined,
      volumeUpdatedAtMs: isSet(object.volumeUpdatedAtMs)
        ? globalThis.String(object.volumeUpdatedAtMs)
        : isSet(object.volume_updated_at_ms)
          ? globalThis.String(object.volume_updated_at_ms)
          : undefined,
      iconTag: isSet(object.iconTag)
        ? globalThis.String(object.iconTag)
        : isSet(object.icon_tag)
          ? globalThis.String(object.icon_tag)
          : undefined,
      regionTags: globalThis.Array.isArray(object?.regionTags)
        ? object.regionTags.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.region_tags)
          ? object.region_tags.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: InstrumentEnrichment): unknown {
    const obj: any = {}
    if (message.canonicalGroup !== '') {
      obj.canonicalGroup = message.canonicalGroup
    }
    if (message.assetClass !== 0) {
      obj.assetClass = assetClassToJSON(message.assetClass)
    }
    if (message.sectorTags?.length) {
      obj.sectorTags = message.sectorTags
    }
    if (message.displayName !== '') {
      obj.displayName = message.displayName
    }
    if (message.description !== '') {
      obj.description = message.description
    }
    if (message.status !== 0) {
      obj.status = enrichmentStatusToJSON(message.status)
    }
    if (message.source !== 0) {
      obj.source = enrichmentSourceToJSON(message.source)
    }
    if (message.confidence !== undefined) {
      obj.confidence = message.confidence
    }
    if (message.enrichedAtMs !== undefined) {
      obj.enrichedAtMs = message.enrichedAtMs
    }
    if (message.volume24h !== undefined) {
      obj.volume24h = message.volume24h
    }
    if (message.volumeUpdatedAtMs !== undefined) {
      obj.volumeUpdatedAtMs = message.volumeUpdatedAtMs
    }
    if (message.iconTag !== undefined) {
      obj.iconTag = message.iconTag
    }
    if (message.regionTags?.length) {
      obj.regionTags = message.regionTags
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentEnrichment>, I>>(base?: I): InstrumentEnrichment {
    return InstrumentEnrichment.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentEnrichment>, I>>(
    object: I
  ): InstrumentEnrichment {
    const message = createBaseInstrumentEnrichment()
    message.canonicalGroup = object.canonicalGroup ?? ''
    message.assetClass = object.assetClass ?? 0
    message.sectorTags = object.sectorTags?.map((e) => e) || []
    message.displayName = object.displayName ?? ''
    message.description = object.description ?? ''
    message.status = object.status ?? 0
    message.source = object.source ?? 0
    message.confidence = object.confidence ?? undefined
    message.enrichedAtMs = object.enrichedAtMs ?? undefined
    message.volume24h = object.volume24h ?? undefined
    message.volumeUpdatedAtMs = object.volumeUpdatedAtMs ?? undefined
    message.iconTag = object.iconTag ?? undefined
    message.regionTags = object.regionTags?.map((e) => e) || []
    return message
  },
}

function createBaseUnderlyingRef(): UnderlyingRef {
  return { exchange: 0, symbol: '' }
}

export const UnderlyingRef: MessageFns<UnderlyingRef> = {
  encode(message: UnderlyingRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exchange !== 0) {
      writer.uint32(8).int32(message.exchange)
    }
    if (message.symbol !== '') {
      writer.uint32(18).string(message.symbol)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnderlyingRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUnderlyingRef()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.symbol = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UnderlyingRef {
    return {
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
    }
  },

  toJSON(message: UnderlyingRef): unknown {
    const obj: any = {}
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UnderlyingRef>, I>>(base?: I): UnderlyingRef {
    return UnderlyingRef.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UnderlyingRef>, I>>(object: I): UnderlyingRef {
    const message = createBaseUnderlyingRef()
    message.exchange = object.exchange ?? 0
    message.symbol = object.symbol ?? ''
    return message
  },
}

function createBaseTickSizeStep(): TickSizeStep {
  return { abovePrice: '', tickSize: '' }
}

export const TickSizeStep: MessageFns<TickSizeStep> = {
  encode(message: TickSizeStep, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.abovePrice !== '') {
      writer.uint32(10).string(message.abovePrice)
    }
    if (message.tickSize !== '') {
      writer.uint32(18).string(message.tickSize)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TickSizeStep {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTickSizeStep()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.abovePrice = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.tickSize = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TickSizeStep {
    return {
      abovePrice: isSet(object.abovePrice)
        ? globalThis.String(object.abovePrice)
        : isSet(object.above_price)
          ? globalThis.String(object.above_price)
          : '',
      tickSize: isSet(object.tickSize)
        ? globalThis.String(object.tickSize)
        : isSet(object.tick_size)
          ? globalThis.String(object.tick_size)
          : '',
    }
  },

  toJSON(message: TickSizeStep): unknown {
    const obj: any = {}
    if (message.abovePrice !== '') {
      obj.abovePrice = message.abovePrice
    }
    if (message.tickSize !== '') {
      obj.tickSize = message.tickSize
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TickSizeStep>, I>>(base?: I): TickSizeStep {
    return TickSizeStep.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TickSizeStep>, I>>(object: I): TickSizeStep {
    const message = createBaseTickSizeStep()
    message.abovePrice = object.abovePrice ?? ''
    message.tickSize = object.tickSize ?? ''
    return message
  },
}

function createBaseTicker(): Ticker {
  return {
    symbol: '',
    exchange: 0,
    bidPrice: undefined,
    askPrice: undefined,
    bestBidQuantity: undefined,
    bestAskQuantity: undefined,
    lastPrice: undefined,
    volume24h: undefined,
    priceChange24h: undefined,
    priceChangePercent24h: undefined,
    high24h: undefined,
    low24h: undefined,
    minPrice: undefined,
    maxPrice: undefined,
    iv: undefined,
    openInterest: undefined,
    indexPrice: undefined,
    markPrice: undefined,
    strikePrice: undefined,
    expiry: undefined,
    fundingRate: undefined,
    logReturn: undefined,
    underlyingPrice: undefined,
    underlying: undefined,
    optionType: undefined,
    nextFundingTime: undefined,
    timestamp: '0',
  }
}

export const Ticker: MessageFns<Ticker> = {
  encode(message: Ticker, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.exchange !== 0) {
      writer.uint32(16).int32(message.exchange)
    }
    if (message.bidPrice !== undefined) {
      writer.uint32(26).string(message.bidPrice)
    }
    if (message.askPrice !== undefined) {
      writer.uint32(34).string(message.askPrice)
    }
    if (message.bestBidQuantity !== undefined) {
      writer.uint32(178).string(message.bestBidQuantity)
    }
    if (message.bestAskQuantity !== undefined) {
      writer.uint32(186).string(message.bestAskQuantity)
    }
    if (message.lastPrice !== undefined) {
      writer.uint32(42).string(message.lastPrice)
    }
    if (message.volume24h !== undefined) {
      writer.uint32(50).string(message.volume24h)
    }
    if (message.priceChange24h !== undefined) {
      writer.uint32(58).string(message.priceChange24h)
    }
    if (message.priceChangePercent24h !== undefined) {
      writer.uint32(66).string(message.priceChangePercent24h)
    }
    if (message.high24h !== undefined) {
      writer.uint32(74).string(message.high24h)
    }
    if (message.low24h !== undefined) {
      writer.uint32(82).string(message.low24h)
    }
    if (message.minPrice !== undefined) {
      writer.uint32(90).string(message.minPrice)
    }
    if (message.maxPrice !== undefined) {
      writer.uint32(98).string(message.maxPrice)
    }
    if (message.iv !== undefined) {
      writer.uint32(106).string(message.iv)
    }
    if (message.openInterest !== undefined) {
      writer.uint32(114).string(message.openInterest)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(122).string(message.indexPrice)
    }
    if (message.markPrice !== undefined) {
      writer.uint32(130).string(message.markPrice)
    }
    if (message.strikePrice !== undefined) {
      writer.uint32(138).string(message.strikePrice)
    }
    if (message.expiry !== undefined) {
      writer.uint32(144).int64(message.expiry)
    }
    if (message.fundingRate !== undefined) {
      writer.uint32(154).string(message.fundingRate)
    }
    if (message.logReturn !== undefined) {
      writer.uint32(162).string(message.logReturn)
    }
    if (message.underlyingPrice !== undefined) {
      writer.uint32(194).string(message.underlyingPrice)
    }
    if (message.underlying !== undefined) {
      writer.uint32(202).string(message.underlying)
    }
    if (message.optionType !== undefined) {
      writer.uint32(208).int32(message.optionType)
    }
    if (message.nextFundingTime !== undefined) {
      writer.uint32(216).int64(message.nextFundingTime)
    }
    if (message.timestamp !== '0') {
      writer.uint32(168).int64(message.timestamp)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Ticker {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTicker()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.bidPrice = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.askPrice = reader.string()
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.bestBidQuantity = reader.string()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.bestAskQuantity = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.lastPrice = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.volume24h = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.priceChange24h = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.priceChangePercent24h = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.high24h = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.low24h = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.minPrice = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.maxPrice = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.iv = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.openInterest = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.markPrice = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.strikePrice = reader.string()
          continue
        }
        case 18: {
          if (tag !== 144) {
            break
          }

          message.expiry = reader.int64().toString()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.fundingRate = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.logReturn = reader.string()
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.underlyingPrice = reader.string()
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.underlying = reader.string()
          continue
        }
        case 26: {
          if (tag !== 208) {
            break
          }

          message.optionType = reader.int32() as any
          continue
        }
        case 27: {
          if (tag !== 216) {
            break
          }

          message.nextFundingTime = reader.int64().toString()
          continue
        }
        case 21: {
          if (tag !== 168) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Ticker {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      bidPrice: isSet(object.bidPrice)
        ? globalThis.String(object.bidPrice)
        : isSet(object.bid_price)
          ? globalThis.String(object.bid_price)
          : undefined,
      askPrice: isSet(object.askPrice)
        ? globalThis.String(object.askPrice)
        : isSet(object.ask_price)
          ? globalThis.String(object.ask_price)
          : undefined,
      bestBidQuantity: isSet(object.bestBidQuantity)
        ? globalThis.String(object.bestBidQuantity)
        : isSet(object.best_bid_quantity)
          ? globalThis.String(object.best_bid_quantity)
          : undefined,
      bestAskQuantity: isSet(object.bestAskQuantity)
        ? globalThis.String(object.bestAskQuantity)
        : isSet(object.best_ask_quantity)
          ? globalThis.String(object.best_ask_quantity)
          : undefined,
      lastPrice: isSet(object.lastPrice)
        ? globalThis.String(object.lastPrice)
        : isSet(object.last_price)
          ? globalThis.String(object.last_price)
          : undefined,
      volume24h: isSet(object.volume24h)
        ? globalThis.String(object.volume24h)
        : isSet(object.volume_24h)
          ? globalThis.String(object.volume_24h)
          : undefined,
      priceChange24h: isSet(object.priceChange24h)
        ? globalThis.String(object.priceChange24h)
        : isSet(object.price_change_24h)
          ? globalThis.String(object.price_change_24h)
          : undefined,
      priceChangePercent24h: isSet(object.priceChangePercent24h)
        ? globalThis.String(object.priceChangePercent24h)
        : isSet(object.price_change_percent_24h)
          ? globalThis.String(object.price_change_percent_24h)
          : undefined,
      high24h: isSet(object.high24h)
        ? globalThis.String(object.high24h)
        : isSet(object.high_24h)
          ? globalThis.String(object.high_24h)
          : undefined,
      low24h: isSet(object.low24h)
        ? globalThis.String(object.low24h)
        : isSet(object.low_24h)
          ? globalThis.String(object.low_24h)
          : undefined,
      minPrice: isSet(object.minPrice)
        ? globalThis.String(object.minPrice)
        : isSet(object.min_price)
          ? globalThis.String(object.min_price)
          : undefined,
      maxPrice: isSet(object.maxPrice)
        ? globalThis.String(object.maxPrice)
        : isSet(object.max_price)
          ? globalThis.String(object.max_price)
          : undefined,
      iv: isSet(object.iv) ? globalThis.String(object.iv) : undefined,
      openInterest: isSet(object.openInterest)
        ? globalThis.String(object.openInterest)
        : isSet(object.open_interest)
          ? globalThis.String(object.open_interest)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      markPrice: isSet(object.markPrice)
        ? globalThis.String(object.markPrice)
        : isSet(object.mark_price)
          ? globalThis.String(object.mark_price)
          : undefined,
      strikePrice: isSet(object.strikePrice)
        ? globalThis.String(object.strikePrice)
        : isSet(object.strike_price)
          ? globalThis.String(object.strike_price)
          : undefined,
      expiry: isSet(object.expiry) ? globalThis.String(object.expiry) : undefined,
      fundingRate: isSet(object.fundingRate)
        ? globalThis.String(object.fundingRate)
        : isSet(object.funding_rate)
          ? globalThis.String(object.funding_rate)
          : undefined,
      logReturn: isSet(object.logReturn)
        ? globalThis.String(object.logReturn)
        : isSet(object.log_return)
          ? globalThis.String(object.log_return)
          : undefined,
      underlyingPrice: isSet(object.underlyingPrice)
        ? globalThis.String(object.underlyingPrice)
        : isSet(object.underlying_price)
          ? globalThis.String(object.underlying_price)
          : undefined,
      underlying: isSet(object.underlying) ? globalThis.String(object.underlying) : undefined,
      optionType: isSet(object.optionType)
        ? optionTypeFromJSON(object.optionType)
        : isSet(object.option_type)
          ? optionTypeFromJSON(object.option_type)
          : undefined,
      nextFundingTime: isSet(object.nextFundingTime)
        ? globalThis.String(object.nextFundingTime)
        : isSet(object.next_funding_time)
          ? globalThis.String(object.next_funding_time)
          : undefined,
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
    }
  },

  toJSON(message: Ticker): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.bidPrice !== undefined) {
      obj.bidPrice = message.bidPrice
    }
    if (message.askPrice !== undefined) {
      obj.askPrice = message.askPrice
    }
    if (message.bestBidQuantity !== undefined) {
      obj.bestBidQuantity = message.bestBidQuantity
    }
    if (message.bestAskQuantity !== undefined) {
      obj.bestAskQuantity = message.bestAskQuantity
    }
    if (message.lastPrice !== undefined) {
      obj.lastPrice = message.lastPrice
    }
    if (message.volume24h !== undefined) {
      obj.volume24h = message.volume24h
    }
    if (message.priceChange24h !== undefined) {
      obj.priceChange24h = message.priceChange24h
    }
    if (message.priceChangePercent24h !== undefined) {
      obj.priceChangePercent24h = message.priceChangePercent24h
    }
    if (message.high24h !== undefined) {
      obj.high24h = message.high24h
    }
    if (message.low24h !== undefined) {
      obj.low24h = message.low24h
    }
    if (message.minPrice !== undefined) {
      obj.minPrice = message.minPrice
    }
    if (message.maxPrice !== undefined) {
      obj.maxPrice = message.maxPrice
    }
    if (message.iv !== undefined) {
      obj.iv = message.iv
    }
    if (message.openInterest !== undefined) {
      obj.openInterest = message.openInterest
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.markPrice !== undefined) {
      obj.markPrice = message.markPrice
    }
    if (message.strikePrice !== undefined) {
      obj.strikePrice = message.strikePrice
    }
    if (message.expiry !== undefined) {
      obj.expiry = message.expiry
    }
    if (message.fundingRate !== undefined) {
      obj.fundingRate = message.fundingRate
    }
    if (message.logReturn !== undefined) {
      obj.logReturn = message.logReturn
    }
    if (message.underlyingPrice !== undefined) {
      obj.underlyingPrice = message.underlyingPrice
    }
    if (message.underlying !== undefined) {
      obj.underlying = message.underlying
    }
    if (message.optionType !== undefined) {
      obj.optionType = optionTypeToJSON(message.optionType)
    }
    if (message.nextFundingTime !== undefined) {
      obj.nextFundingTime = message.nextFundingTime
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Ticker>, I>>(base?: I): Ticker {
    return Ticker.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Ticker>, I>>(object: I): Ticker {
    const message = createBaseTicker()
    message.symbol = object.symbol ?? ''
    message.exchange = object.exchange ?? 0
    message.bidPrice = object.bidPrice ?? undefined
    message.askPrice = object.askPrice ?? undefined
    message.bestBidQuantity = object.bestBidQuantity ?? undefined
    message.bestAskQuantity = object.bestAskQuantity ?? undefined
    message.lastPrice = object.lastPrice ?? undefined
    message.volume24h = object.volume24h ?? undefined
    message.priceChange24h = object.priceChange24h ?? undefined
    message.priceChangePercent24h = object.priceChangePercent24h ?? undefined
    message.high24h = object.high24h ?? undefined
    message.low24h = object.low24h ?? undefined
    message.minPrice = object.minPrice ?? undefined
    message.maxPrice = object.maxPrice ?? undefined
    message.iv = object.iv ?? undefined
    message.openInterest = object.openInterest ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    message.markPrice = object.markPrice ?? undefined
    message.strikePrice = object.strikePrice ?? undefined
    message.expiry = object.expiry ?? undefined
    message.fundingRate = object.fundingRate ?? undefined
    message.logReturn = object.logReturn ?? undefined
    message.underlyingPrice = object.underlyingPrice ?? undefined
    message.underlying = object.underlying ?? undefined
    message.optionType = object.optionType ?? undefined
    message.nextFundingTime = object.nextFundingTime ?? undefined
    message.timestamp = object.timestamp ?? '0'
    return message
  },
}

function createBaseGreeks(): Greeks {
  return { delta: undefined, gamma: undefined, theta: undefined, vega: undefined, rho: undefined }
}

export const Greeks: MessageFns<Greeks> = {
  encode(message: Greeks, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.delta !== undefined) {
      writer.uint32(10).string(message.delta)
    }
    if (message.gamma !== undefined) {
      writer.uint32(18).string(message.gamma)
    }
    if (message.theta !== undefined) {
      writer.uint32(26).string(message.theta)
    }
    if (message.vega !== undefined) {
      writer.uint32(34).string(message.vega)
    }
    if (message.rho !== undefined) {
      writer.uint32(42).string(message.rho)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Greeks {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGreeks()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.delta = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.gamma = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.theta = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.vega = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.rho = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Greeks {
    return {
      delta: isSet(object.delta) ? globalThis.String(object.delta) : undefined,
      gamma: isSet(object.gamma) ? globalThis.String(object.gamma) : undefined,
      theta: isSet(object.theta) ? globalThis.String(object.theta) : undefined,
      vega: isSet(object.vega) ? globalThis.String(object.vega) : undefined,
      rho: isSet(object.rho) ? globalThis.String(object.rho) : undefined,
    }
  },

  toJSON(message: Greeks): unknown {
    const obj: any = {}
    if (message.delta !== undefined) {
      obj.delta = message.delta
    }
    if (message.gamma !== undefined) {
      obj.gamma = message.gamma
    }
    if (message.theta !== undefined) {
      obj.theta = message.theta
    }
    if (message.vega !== undefined) {
      obj.vega = message.vega
    }
    if (message.rho !== undefined) {
      obj.rho = message.rho
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Greeks>, I>>(base?: I): Greeks {
    return Greeks.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Greeks>, I>>(object: I): Greeks {
    const message = createBaseGreeks()
    message.delta = object.delta ?? undefined
    message.gamma = object.gamma ?? undefined
    message.theta = object.theta ?? undefined
    message.vega = object.vega ?? undefined
    message.rho = object.rho ?? undefined
    return message
  },
}

function createBaseTickerStats(): TickerStats {
  return {
    high: undefined,
    low: undefined,
    priceChangePercent: undefined,
    volumeBase: undefined,
    volumeQuote: undefined,
  }
}

export const TickerStats: MessageFns<TickerStats> = {
  encode(message: TickerStats, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.high !== undefined) {
      writer.uint32(10).string(message.high)
    }
    if (message.low !== undefined) {
      writer.uint32(18).string(message.low)
    }
    if (message.priceChangePercent !== undefined) {
      writer.uint32(26).string(message.priceChangePercent)
    }
    if (message.volumeBase !== undefined) {
      writer.uint32(34).string(message.volumeBase)
    }
    if (message.volumeQuote !== undefined) {
      writer.uint32(42).string(message.volumeQuote)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TickerStats {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTickerStats()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.high = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.low = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.priceChangePercent = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.volumeBase = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.volumeQuote = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TickerStats {
    return {
      high: isSet(object.high) ? globalThis.String(object.high) : undefined,
      low: isSet(object.low) ? globalThis.String(object.low) : undefined,
      priceChangePercent: isSet(object.priceChangePercent)
        ? globalThis.String(object.priceChangePercent)
        : isSet(object.price_change_percent)
          ? globalThis.String(object.price_change_percent)
          : undefined,
      volumeBase: isSet(object.volumeBase)
        ? globalThis.String(object.volumeBase)
        : isSet(object.volume_base)
          ? globalThis.String(object.volume_base)
          : undefined,
      volumeQuote: isSet(object.volumeQuote)
        ? globalThis.String(object.volumeQuote)
        : isSet(object.volume_quote)
          ? globalThis.String(object.volume_quote)
          : undefined,
    }
  },

  toJSON(message: TickerStats): unknown {
    const obj: any = {}
    if (message.high !== undefined) {
      obj.high = message.high
    }
    if (message.low !== undefined) {
      obj.low = message.low
    }
    if (message.priceChangePercent !== undefined) {
      obj.priceChangePercent = message.priceChangePercent
    }
    if (message.volumeBase !== undefined) {
      obj.volumeBase = message.volumeBase
    }
    if (message.volumeQuote !== undefined) {
      obj.volumeQuote = message.volumeQuote
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TickerStats>, I>>(base?: I): TickerStats {
    return TickerStats.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TickerStats>, I>>(object: I): TickerStats {
    const message = createBaseTickerStats()
    message.high = object.high ?? undefined
    message.low = object.low ?? undefined
    message.priceChangePercent = object.priceChangePercent ?? undefined
    message.volumeBase = object.volumeBase ?? undefined
    message.volumeQuote = object.volumeQuote ?? undefined
    return message
  },
}

function createBaseIncrementalTicker(): IncrementalTicker {
  return {
    symbol: '',
    timestamp: '0',
    type: 0,
    state: undefined,
    exchange: 0,
    lastPrice: undefined,
    bestBidPrice: undefined,
    bestAskPrice: undefined,
    markPrice: undefined,
    indexPrice: undefined,
    settlementPrice: undefined,
    bestBidQuantity: undefined,
    bestAskQuantity: undefined,
    openInterest: undefined,
    markIv: undefined,
    bidIv: undefined,
    askIv: undefined,
    underlyingPrice: undefined,
    underlyingIndex: undefined,
    interestRate: undefined,
    greeks: undefined,
    stats: undefined,
    minPrice: undefined,
    maxPrice: undefined,
    estimatedDeliveryPrice: undefined,
    fundingRate: undefined,
    nextFundingTime: undefined,
  }
}

export const IncrementalTicker: MessageFns<IncrementalTicker> = {
  encode(message: IncrementalTicker, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.timestamp !== '0') {
      writer.uint32(16).int64(message.timestamp)
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type)
    }
    if (message.state !== undefined) {
      writer.uint32(34).string(message.state)
    }
    if (message.exchange !== 0) {
      writer.uint32(240).int32(message.exchange)
    }
    if (message.lastPrice !== undefined) {
      writer.uint32(42).string(message.lastPrice)
    }
    if (message.bestBidPrice !== undefined) {
      writer.uint32(50).string(message.bestBidPrice)
    }
    if (message.bestAskPrice !== undefined) {
      writer.uint32(58).string(message.bestAskPrice)
    }
    if (message.markPrice !== undefined) {
      writer.uint32(66).string(message.markPrice)
    }
    if (message.indexPrice !== undefined) {
      writer.uint32(74).string(message.indexPrice)
    }
    if (message.settlementPrice !== undefined) {
      writer.uint32(82).string(message.settlementPrice)
    }
    if (message.bestBidQuantity !== undefined) {
      writer.uint32(90).string(message.bestBidQuantity)
    }
    if (message.bestAskQuantity !== undefined) {
      writer.uint32(98).string(message.bestAskQuantity)
    }
    if (message.openInterest !== undefined) {
      writer.uint32(106).string(message.openInterest)
    }
    if (message.markIv !== undefined) {
      writer.uint32(114).string(message.markIv)
    }
    if (message.bidIv !== undefined) {
      writer.uint32(122).string(message.bidIv)
    }
    if (message.askIv !== undefined) {
      writer.uint32(130).string(message.askIv)
    }
    if (message.underlyingPrice !== undefined) {
      writer.uint32(138).string(message.underlyingPrice)
    }
    if (message.underlyingIndex !== undefined) {
      writer.uint32(146).string(message.underlyingIndex)
    }
    if (message.interestRate !== undefined) {
      writer.uint32(154).string(message.interestRate)
    }
    if (message.greeks !== undefined) {
      Greeks.encode(message.greeks, writer.uint32(162).fork()).join()
    }
    if (message.stats !== undefined) {
      TickerStats.encode(message.stats, writer.uint32(170).fork()).join()
    }
    if (message.minPrice !== undefined) {
      writer.uint32(178).string(message.minPrice)
    }
    if (message.maxPrice !== undefined) {
      writer.uint32(186).string(message.maxPrice)
    }
    if (message.estimatedDeliveryPrice !== undefined) {
      writer.uint32(194).string(message.estimatedDeliveryPrice)
    }
    if (message.fundingRate !== undefined) {
      writer.uint32(202).string(message.fundingRate)
    }
    if (message.nextFundingTime !== undefined) {
      writer.uint32(208).int64(message.nextFundingTime)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IncrementalTicker {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIncrementalTicker()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.type = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.state = reader.string()
          continue
        }
        case 30: {
          if (tag !== 240) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.lastPrice = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.bestBidPrice = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.bestAskPrice = reader.string()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.markPrice = reader.string()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.indexPrice = reader.string()
          continue
        }
        case 10: {
          if (tag !== 82) {
            break
          }

          message.settlementPrice = reader.string()
          continue
        }
        case 11: {
          if (tag !== 90) {
            break
          }

          message.bestBidQuantity = reader.string()
          continue
        }
        case 12: {
          if (tag !== 98) {
            break
          }

          message.bestAskQuantity = reader.string()
          continue
        }
        case 13: {
          if (tag !== 106) {
            break
          }

          message.openInterest = reader.string()
          continue
        }
        case 14: {
          if (tag !== 114) {
            break
          }

          message.markIv = reader.string()
          continue
        }
        case 15: {
          if (tag !== 122) {
            break
          }

          message.bidIv = reader.string()
          continue
        }
        case 16: {
          if (tag !== 130) {
            break
          }

          message.askIv = reader.string()
          continue
        }
        case 17: {
          if (tag !== 138) {
            break
          }

          message.underlyingPrice = reader.string()
          continue
        }
        case 18: {
          if (tag !== 146) {
            break
          }

          message.underlyingIndex = reader.string()
          continue
        }
        case 19: {
          if (tag !== 154) {
            break
          }

          message.interestRate = reader.string()
          continue
        }
        case 20: {
          if (tag !== 162) {
            break
          }

          message.greeks = Greeks.decode(reader, reader.uint32())
          continue
        }
        case 21: {
          if (tag !== 170) {
            break
          }

          message.stats = TickerStats.decode(reader, reader.uint32())
          continue
        }
        case 22: {
          if (tag !== 178) {
            break
          }

          message.minPrice = reader.string()
          continue
        }
        case 23: {
          if (tag !== 186) {
            break
          }

          message.maxPrice = reader.string()
          continue
        }
        case 24: {
          if (tag !== 194) {
            break
          }

          message.estimatedDeliveryPrice = reader.string()
          continue
        }
        case 25: {
          if (tag !== 202) {
            break
          }

          message.fundingRate = reader.string()
          continue
        }
        case 26: {
          if (tag !== 208) {
            break
          }

          message.nextFundingTime = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IncrementalTicker {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      type: isSet(object.type) ? updateTypeFromJSON(object.type) : 0,
      state: isSet(object.state) ? globalThis.String(object.state) : undefined,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
      lastPrice: isSet(object.lastPrice)
        ? globalThis.String(object.lastPrice)
        : isSet(object.last_price)
          ? globalThis.String(object.last_price)
          : undefined,
      bestBidPrice: isSet(object.bestBidPrice)
        ? globalThis.String(object.bestBidPrice)
        : isSet(object.best_bid_price)
          ? globalThis.String(object.best_bid_price)
          : undefined,
      bestAskPrice: isSet(object.bestAskPrice)
        ? globalThis.String(object.bestAskPrice)
        : isSet(object.best_ask_price)
          ? globalThis.String(object.best_ask_price)
          : undefined,
      markPrice: isSet(object.markPrice)
        ? globalThis.String(object.markPrice)
        : isSet(object.mark_price)
          ? globalThis.String(object.mark_price)
          : undefined,
      indexPrice: isSet(object.indexPrice)
        ? globalThis.String(object.indexPrice)
        : isSet(object.index_price)
          ? globalThis.String(object.index_price)
          : undefined,
      settlementPrice: isSet(object.settlementPrice)
        ? globalThis.String(object.settlementPrice)
        : isSet(object.settlement_price)
          ? globalThis.String(object.settlement_price)
          : undefined,
      bestBidQuantity: isSet(object.bestBidQuantity)
        ? globalThis.String(object.bestBidQuantity)
        : isSet(object.best_bid_quantity)
          ? globalThis.String(object.best_bid_quantity)
          : undefined,
      bestAskQuantity: isSet(object.bestAskQuantity)
        ? globalThis.String(object.bestAskQuantity)
        : isSet(object.best_ask_quantity)
          ? globalThis.String(object.best_ask_quantity)
          : undefined,
      openInterest: isSet(object.openInterest)
        ? globalThis.String(object.openInterest)
        : isSet(object.open_interest)
          ? globalThis.String(object.open_interest)
          : undefined,
      markIv: isSet(object.markIv)
        ? globalThis.String(object.markIv)
        : isSet(object.mark_iv)
          ? globalThis.String(object.mark_iv)
          : undefined,
      bidIv: isSet(object.bidIv)
        ? globalThis.String(object.bidIv)
        : isSet(object.bid_iv)
          ? globalThis.String(object.bid_iv)
          : undefined,
      askIv: isSet(object.askIv)
        ? globalThis.String(object.askIv)
        : isSet(object.ask_iv)
          ? globalThis.String(object.ask_iv)
          : undefined,
      underlyingPrice: isSet(object.underlyingPrice)
        ? globalThis.String(object.underlyingPrice)
        : isSet(object.underlying_price)
          ? globalThis.String(object.underlying_price)
          : undefined,
      underlyingIndex: isSet(object.underlyingIndex)
        ? globalThis.String(object.underlyingIndex)
        : isSet(object.underlying_index)
          ? globalThis.String(object.underlying_index)
          : undefined,
      interestRate: isSet(object.interestRate)
        ? globalThis.String(object.interestRate)
        : isSet(object.interest_rate)
          ? globalThis.String(object.interest_rate)
          : undefined,
      greeks: isSet(object.greeks) ? Greeks.fromJSON(object.greeks) : undefined,
      stats: isSet(object.stats) ? TickerStats.fromJSON(object.stats) : undefined,
      minPrice: isSet(object.minPrice)
        ? globalThis.String(object.minPrice)
        : isSet(object.min_price)
          ? globalThis.String(object.min_price)
          : undefined,
      maxPrice: isSet(object.maxPrice)
        ? globalThis.String(object.maxPrice)
        : isSet(object.max_price)
          ? globalThis.String(object.max_price)
          : undefined,
      estimatedDeliveryPrice: isSet(object.estimatedDeliveryPrice)
        ? globalThis.String(object.estimatedDeliveryPrice)
        : isSet(object.estimated_delivery_price)
          ? globalThis.String(object.estimated_delivery_price)
          : undefined,
      fundingRate: isSet(object.fundingRate)
        ? globalThis.String(object.fundingRate)
        : isSet(object.funding_rate)
          ? globalThis.String(object.funding_rate)
          : undefined,
      nextFundingTime: isSet(object.nextFundingTime)
        ? globalThis.String(object.nextFundingTime)
        : isSet(object.next_funding_time)
          ? globalThis.String(object.next_funding_time)
          : undefined,
    }
  },

  toJSON(message: IncrementalTicker): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.type !== 0) {
      obj.type = updateTypeToJSON(message.type)
    }
    if (message.state !== undefined) {
      obj.state = message.state
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    if (message.lastPrice !== undefined) {
      obj.lastPrice = message.lastPrice
    }
    if (message.bestBidPrice !== undefined) {
      obj.bestBidPrice = message.bestBidPrice
    }
    if (message.bestAskPrice !== undefined) {
      obj.bestAskPrice = message.bestAskPrice
    }
    if (message.markPrice !== undefined) {
      obj.markPrice = message.markPrice
    }
    if (message.indexPrice !== undefined) {
      obj.indexPrice = message.indexPrice
    }
    if (message.settlementPrice !== undefined) {
      obj.settlementPrice = message.settlementPrice
    }
    if (message.bestBidQuantity !== undefined) {
      obj.bestBidQuantity = message.bestBidQuantity
    }
    if (message.bestAskQuantity !== undefined) {
      obj.bestAskQuantity = message.bestAskQuantity
    }
    if (message.openInterest !== undefined) {
      obj.openInterest = message.openInterest
    }
    if (message.markIv !== undefined) {
      obj.markIv = message.markIv
    }
    if (message.bidIv !== undefined) {
      obj.bidIv = message.bidIv
    }
    if (message.askIv !== undefined) {
      obj.askIv = message.askIv
    }
    if (message.underlyingPrice !== undefined) {
      obj.underlyingPrice = message.underlyingPrice
    }
    if (message.underlyingIndex !== undefined) {
      obj.underlyingIndex = message.underlyingIndex
    }
    if (message.interestRate !== undefined) {
      obj.interestRate = message.interestRate
    }
    if (message.greeks !== undefined) {
      obj.greeks = Greeks.toJSON(message.greeks)
    }
    if (message.stats !== undefined) {
      obj.stats = TickerStats.toJSON(message.stats)
    }
    if (message.minPrice !== undefined) {
      obj.minPrice = message.minPrice
    }
    if (message.maxPrice !== undefined) {
      obj.maxPrice = message.maxPrice
    }
    if (message.estimatedDeliveryPrice !== undefined) {
      obj.estimatedDeliveryPrice = message.estimatedDeliveryPrice
    }
    if (message.fundingRate !== undefined) {
      obj.fundingRate = message.fundingRate
    }
    if (message.nextFundingTime !== undefined) {
      obj.nextFundingTime = message.nextFundingTime
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IncrementalTicker>, I>>(base?: I): IncrementalTicker {
    return IncrementalTicker.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IncrementalTicker>, I>>(object: I): IncrementalTicker {
    const message = createBaseIncrementalTicker()
    message.symbol = object.symbol ?? ''
    message.timestamp = object.timestamp ?? '0'
    message.type = object.type ?? 0
    message.state = object.state ?? undefined
    message.exchange = object.exchange ?? 0
    message.lastPrice = object.lastPrice ?? undefined
    message.bestBidPrice = object.bestBidPrice ?? undefined
    message.bestAskPrice = object.bestAskPrice ?? undefined
    message.markPrice = object.markPrice ?? undefined
    message.indexPrice = object.indexPrice ?? undefined
    message.settlementPrice = object.settlementPrice ?? undefined
    message.bestBidQuantity = object.bestBidQuantity ?? undefined
    message.bestAskQuantity = object.bestAskQuantity ?? undefined
    message.openInterest = object.openInterest ?? undefined
    message.markIv = object.markIv ?? undefined
    message.bidIv = object.bidIv ?? undefined
    message.askIv = object.askIv ?? undefined
    message.underlyingPrice = object.underlyingPrice ?? undefined
    message.underlyingIndex = object.underlyingIndex ?? undefined
    message.interestRate = object.interestRate ?? undefined
    message.greeks =
      object.greeks !== undefined && object.greeks !== null
        ? Greeks.fromPartial(object.greeks)
        : undefined
    message.stats =
      object.stats !== undefined && object.stats !== null
        ? TickerStats.fromPartial(object.stats)
        : undefined
    message.minPrice = object.minPrice ?? undefined
    message.maxPrice = object.maxPrice ?? undefined
    message.estimatedDeliveryPrice = object.estimatedDeliveryPrice ?? undefined
    message.fundingRate = object.fundingRate ?? undefined
    message.nextFundingTime = object.nextFundingTime ?? undefined
    return message
  },
}

function createBaseInstrumentState(): InstrumentState {
  return { symbol: '', timestamp: '0', state: 0, exchange: 0 }
}

export const InstrumentState: MessageFns<InstrumentState> = {
  encode(message: InstrumentState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.symbol !== '') {
      writer.uint32(10).string(message.symbol)
    }
    if (message.timestamp !== '0') {
      writer.uint32(16).int64(message.timestamp)
    }
    if (message.state !== 0) {
      writer.uint32(24).int32(message.state)
    }
    if (message.exchange !== 0) {
      writer.uint32(32).int32(message.exchange)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.symbol = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.timestamp = reader.int64().toString()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.state = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.exchange = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentState {
    return {
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : '0',
      state: isSet(object.state) ? instrumentStateTypeFromJSON(object.state) : 0,
      exchange: isSet(object.exchange) ? exchangeFromJSON(object.exchange) : 0,
    }
  },

  toJSON(message: InstrumentState): unknown {
    const obj: any = {}
    if (message.symbol !== '') {
      obj.symbol = message.symbol
    }
    if (message.timestamp !== '0') {
      obj.timestamp = message.timestamp
    }
    if (message.state !== 0) {
      obj.state = instrumentStateTypeToJSON(message.state)
    }
    if (message.exchange !== 0) {
      obj.exchange = exchangeToJSON(message.exchange)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentState>, I>>(base?: I): InstrumentState {
    return InstrumentState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentState>, I>>(object: I): InstrumentState {
    const message = createBaseInstrumentState()
    message.symbol = object.symbol ?? ''
    message.timestamp = object.timestamp ?? '0'
    message.state = object.state ?? 0
    message.exchange = object.exchange ?? 0
    return message
  },
}

function createBaseInstrumentStateList(): InstrumentStateList {
  return { instrumentStates: [] }
}

export const InstrumentStateList: MessageFns<InstrumentStateList> = {
  encode(message: InstrumentStateList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.instrumentStates) {
      InstrumentState.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentStateList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentStateList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrumentStates.push(InstrumentState.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentStateList {
    return {
      instrumentStates: globalThis.Array.isArray(object?.instrumentStates)
        ? object.instrumentStates.map((e: any) => InstrumentState.fromJSON(e))
        : globalThis.Array.isArray(object?.instrument_states)
          ? object.instrument_states.map((e: any) => InstrumentState.fromJSON(e))
          : [],
    }
  },

  toJSON(message: InstrumentStateList): unknown {
    const obj: any = {}
    if (message.instrumentStates?.length) {
      obj.instrumentStates = message.instrumentStates.map((e) => InstrumentState.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentStateList>, I>>(base?: I): InstrumentStateList {
    return InstrumentStateList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentStateList>, I>>(
    object: I
  ): InstrumentStateList {
    const message = createBaseInstrumentStateList()
    message.instrumentStates =
      object.instrumentStates?.map((e) => InstrumentState.fromPartial(e)) || []
    return message
  },
}

function createBaseIncrementalTickerList(): IncrementalTickerList {
  return { incrementalTickers: [] }
}

export const IncrementalTickerList: MessageFns<IncrementalTickerList> = {
  encode(message: IncrementalTickerList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.incrementalTickers) {
      IncrementalTicker.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IncrementalTickerList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIncrementalTickerList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.incrementalTickers.push(IncrementalTicker.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IncrementalTickerList {
    return {
      incrementalTickers: globalThis.Array.isArray(object?.incrementalTickers)
        ? object.incrementalTickers.map((e: any) => IncrementalTicker.fromJSON(e))
        : globalThis.Array.isArray(object?.incremental_tickers)
          ? object.incremental_tickers.map((e: any) => IncrementalTicker.fromJSON(e))
          : [],
    }
  },

  toJSON(message: IncrementalTickerList): unknown {
    const obj: any = {}
    if (message.incrementalTickers?.length) {
      obj.incrementalTickers = message.incrementalTickers.map((e) => IncrementalTicker.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IncrementalTickerList>, I>>(base?: I): IncrementalTickerList {
    return IncrementalTickerList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IncrementalTickerList>, I>>(
    object: I
  ): IncrementalTickerList {
    const message = createBaseIncrementalTickerList()
    message.incrementalTickers =
      object.incrementalTickers?.map((e) => IncrementalTicker.fromPartial(e)) || []
    return message
  },
}

function createBaseInstrumentList(): InstrumentList {
  return { instruments: [] }
}

export const InstrumentList: MessageFns<InstrumentList> = {
  encode(message: InstrumentList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.instruments) {
      Instrument.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InstrumentList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInstrumentList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instruments.push(Instrument.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InstrumentList {
    return {
      instruments: globalThis.Array.isArray(object?.instruments)
        ? object.instruments.map((e: any) => Instrument.fromJSON(e))
        : [],
    }
  },

  toJSON(message: InstrumentList): unknown {
    const obj: any = {}
    if (message.instruments?.length) {
      obj.instruments = message.instruments.map((e) => Instrument.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InstrumentList>, I>>(base?: I): InstrumentList {
    return InstrumentList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InstrumentList>, I>>(object: I): InstrumentList {
    const message = createBaseInstrumentList()
    message.instruments = object.instruments?.map((e) => Instrument.fromPartial(e)) || []
    return message
  },
}

function createBaseTickerList(): TickerList {
  return { tickers: [] }
}

export const TickerList: MessageFns<TickerList> = {
  encode(message: TickerList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tickers) {
      Ticker.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TickerList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTickerList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tickers.push(Ticker.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TickerList {
    return {
      tickers: globalThis.Array.isArray(object?.tickers)
        ? object.tickers.map((e: any) => Ticker.fromJSON(e))
        : [],
    }
  },

  toJSON(message: TickerList): unknown {
    const obj: any = {}
    if (message.tickers?.length) {
      obj.tickers = message.tickers.map((e) => Ticker.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TickerList>, I>>(base?: I): TickerList {
    return TickerList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TickerList>, I>>(object: I): TickerList {
    const message = createBaseTickerList()
    message.tickers = object.tickers?.map((e) => Ticker.fromPartial(e)) || []
    return message
  },
}

function createBaseOrderBookList(): OrderBookList {
  return { orderBooks: [] }
}

export const OrderBookList: MessageFns<OrderBookList> = {
  encode(message: OrderBookList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.orderBooks) {
      OrderBook.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrderBookList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseOrderBookList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderBooks.push(OrderBook.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): OrderBookList {
    return {
      orderBooks: globalThis.Array.isArray(object?.orderBooks)
        ? object.orderBooks.map((e: any) => OrderBook.fromJSON(e))
        : globalThis.Array.isArray(object?.order_books)
          ? object.order_books.map((e: any) => OrderBook.fromJSON(e))
          : [],
    }
  },

  toJSON(message: OrderBookList): unknown {
    const obj: any = {}
    if (message.orderBooks?.length) {
      obj.orderBooks = message.orderBooks.map((e) => OrderBook.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<OrderBookList>, I>>(base?: I): OrderBookList {
    return OrderBookList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<OrderBookList>, I>>(object: I): OrderBookList {
    const message = createBaseOrderBookList()
    message.orderBooks = object.orderBooks?.map((e) => OrderBook.fromPartial(e)) || []
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
